{
  "orders": [
    {
      "Primary": false,
      "SKU": "77400465",
      "Description": "LANAI OTTOMAN CUSHION LINDY MINERAL",
      "Theme": "LANAI",
      "Available": 16.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.3731,
      "New WOS": 42.883945322969716,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 16.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77301251",
      "Description": "LK COMO CLB CHR CUSH SILK",
      "Theme": "LAKE COMO",
      "Available": 35.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.0,
      "New WOS": 0.0,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 35.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77401253",
      "Description": "LK COMO OTTO CUSH SILK",
      "Theme": "LAKE COMO",
      "Available": 37.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.0,
      "New WOS": 0.0,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 37.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "78401266",
      "Description": "LK COMO ARMLESS CHR CUSH MALT",
      "Theme": "LAKE COMO",
      "Available": 42.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.0,
      "New WOS": 0.0,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 42.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77301504",
      "Description": "LK COMO CLB CHR CUSH COCONUT",
      "Theme": "LAKE COMO",
      "Available": 9.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.0,
      "New WOS": 0.0,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 9.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77401506",
      "Description": "LK COMO OTTO CUSH COCONUT",
      "Theme": "LAKE COMO",
      "Available": 14.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.0,
      "New WOS": 0.0,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 14.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77301605",
      "Description": "LK COMO CLUB CHAIR CUSH SUNBRELLA TERRACOTTA",
      "Theme": "LAKE COMO",
      "Available": 17.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.0,
      "New WOS": 0.0,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 17.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77301706",
      "Description": "LK COMO CLUB CHAIR SUNBRELLA MIST",
      "Theme": "LAKE COMO",
      "Available": 38.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.0,
      "New WOS": 0.0,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 38.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77401708",
      "Description": "LK COMO OTTOMAN SUNBRELLA MIST",
      "Theme": "LAKE COMO",
      "Available": 12.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.0,
      "New WOS": 0.0,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 12.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "78401709",
      "Description": "LK COMO ARMLESS CHAIR SUNBRELLA MIST",
      "Theme": "LAKE COMO",
      "Available": 23.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.28,
      "New WOS": 82.14285714285714,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 23.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "18902216",
      "Description": "0200-PP-A-YJ TP PILLOW PAIR",
      "Theme": "GRACIE",
      "Available": 11.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.0931,
      "New WOS": 118.15252416756177,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 11.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "18903155",
      "Description": "0200-PPBXL-SQ TP PILLOW PAIR",
      "Theme": "TRENDOME",
      "Available": 13.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.0,
      "New WOS": 0.0,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 13.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "75610127",
      "Description": "PATMOS DN A/C CUSH LINEN",
      "Theme": "PATMOS",
      "Available": 36.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.7469,
      "New WOS": 48.199223456955416,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 36.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77110129",
      "Description": "PATMOS SOFA CUSH LINEN",
      "Theme": "PATMOS",
      "Available": 36.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.9331,
      "New WOS": 38.58107383988854,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 36.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77210121",
      "Description": "PATMOS L/S CUSH LINEN",
      "Theme": "PATMOS",
      "Available": 13.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.3731,
      "New WOS": 34.84320557491289,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 13.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77710640",
      "Description": "PB ARMLESS CHR CUSH VAPOR",
      "Theme": "PLEASANT BAY",
      "Available": 18.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.3731,
      "New WOS": 48.244438488340926,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 18.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "75911012",
      "Description": "SIESTA KEY 102\"  BENCH PAD IO TWINE",
      "Theme": "SIESTA KEY",
      "Available": 11.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.0,
      "New WOS": 0.0,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 11.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "75911024",
      "Description": "SIESTA KEY 76' BENCH PAD IO TWINE",
      "Theme": "SIESTA KEY",
      "Available": 8.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.0931,
      "New WOS": 85.92910848549946,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 8.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "75511709",
      "Description": "MONTECELLO DINING ARM CHAIR CUSHION PREMIER MIST",
      "Theme": "MONTECELLO",
      "Available": 39.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.9331,
      "New WOS": 41.79616332654592,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 39.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77511701",
      "Description": "MONTECELLO CHAISE CUSHION MIST",
      "Theme": "MONTECELLO",
      "Available": 16.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.0931,
      "New WOS": 171.8582169709989,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 16.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77212341",
      "Description": "LAKE TAHOE SUNBRELLA SEAGULL LOVESEAT CUSHION",
      "Theme": "LAKE TAHOE",
      "Available": 13.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.3731,
      "New WOS": 34.84320557491289,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 13.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "75512369",
      "Description": "LAKE TAHOE SIDE CHR CUSH INDIGO",
      "Theme": "LAKE TAHOE",
      "Available": 51.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 1.12,
      "New WOS": 45.535714285714285,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 51.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "75612361",
      "Description": "LAKE TAHOE DIN ARM CHR CUSH",
      "Theme": "LAKE TAHOE",
      "Available": 31.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.3731,
      "New WOS": 83.08764406325382,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 31.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77212365",
      "Description": "LAKE TAHOE SUNBRELLA INDIGO LOVESEAT CUSHION",
      "Theme": "LAKE TAHOE",
      "Available": 15.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.3731,
      "New WOS": 40.20369874028411,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 15.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77212377",
      "Description": "LAKE TAHOE LOVESEAT CUSH IO CHARCOAL",
      "Theme": "LAKE TAHOE",
      "Available": 15.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.1869,
      "New WOS": 80.25682182985554,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 15.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "75512408",
      "Description": "LAKE TAHOE DINING SIDE CHAIR CUSHION TERRACOTTA",
      "Theme": "LAKE TAHOE",
      "Available": 16.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.0,
      "New WOS": 0.0,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 16.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "75612400",
      "Description": "LAKE TAHOE DINING ARM CHAIR CUSHION TERRACOTTA",
      "Theme": "LAKE TAHOE",
      "Available": 20.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.0,
      "New WOS": 0.0,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 20.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77112402",
      "Description": "LAKE TAHOE SOFA CUSHION TERRACOTTA",
      "Theme": "LAKE TAHOE",
      "Available": 7.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.1869,
      "New WOS": 37.45318352059925,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 7.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77212404",
      "Description": "LAKE TAHOE LOVESEAT CUSHION TERRACOTTA",
      "Theme": "LAKE TAHOE",
      "Available": 5.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.0931,
      "New WOS": 53.70569280343717,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 5.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77412408",
      "Description": "LAKE TAHOE OTTOMAN CUSHION TERRACOTTA",
      "Theme": "LAKE TAHOE",
      "Available": 5.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.0931,
      "New WOS": 53.70569280343717,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 5.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77512400",
      "Description": "LAKE TAHOE CHAISE CUSHION TERRACOTTA",
      "Theme": "LAKE TAHOE",
      "Available": 10.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.0,
      "New WOS": 0.0,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 10.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "75512509",
      "Description": "LAKE TAHOE DINING SIDE CHAIR CUSHION BUTTERCUP",
      "Theme": "LAKE TAHOE",
      "Available": 20.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.0,
      "New WOS": 0.0,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 20.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "75612501",
      "Description": "LAKE TAHOE DINING ARM CHAIR CUSHION BUTTERCUP",
      "Theme": "LAKE TAHOE",
      "Available": 12.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.0,
      "New WOS": 0.0,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 12.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77112503",
      "Description": "LAKE TAHOE SOFA CUSHION BUTTERCUP",
      "Theme": "LAKE TAHOE",
      "Available": 5.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.0,
      "New WOS": 0.0,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 5.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77212505",
      "Description": "LAKE TAHOE LOVESEAT CUSHION  BUTTERCUP",
      "Theme": "LAKE TAHOE",
      "Available": 5.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.0,
      "New WOS": 0.0,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 5.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77312507",
      "Description": "LAKE TAHOE CLUB CHAIR CUSHION BUTTERCUP",
      "Theme": "LAKE TAHOE",
      "Available": 9.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.1869,
      "New WOS": 48.15409309791332,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 9.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77512501",
      "Description": "LAKE TAHOE CHAISE CUSHION BUTTERCUP",
      "Theme": "LAKE TAHOE",
      "Available": 6.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.0,
      "New WOS": 0.0,
      "Sales Ratio": 0.0,
      "Order": 0.0,
      "AAO": 6.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "78312813",
      "Description": "LAKE BREEZE WEDGE CUSH PARCHMENT",
      "Theme": "LAKE BREEZE",
      "Available": 5.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.1869,
      "New WOS": 32.102728731942214,
      "Sales Ratio": 0.0,
      "Order": 1.0,
      "AAO": 6.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "18902177",
      "Description": "0200-PP-A-YP TP PILLOW PAIR",
      "Theme": "GRACIE",
      "Available": 7.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.28,
      "New WOS": 35.71428571428571,
      "Sales Ratio": 0.0,
      "Order": 3.0,
      "AAO": 10.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77412509",
      "Description": "LAKE TAHOE OTTOMAN CUSHION BUTTERCUP",
      "Theme": "LAKE TAHOE",
      "Available": 3.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.1869,
      "New WOS": 32.102728731942214,
      "Sales Ratio": 0.0,
      "Order": 3.0,
      "AAO": 6.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "75510125",
      "Description": "PATMOS SIDE CHR CUSH LINEN",
      "Theme": "PATMOS",
      "Available": 82.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 2.52,
      "New WOS": 34.12698412698413,
      "Sales Ratio": 0.0,
      "Order": 4.0,
      "AAO": 86.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77412369",
      "Description": "LAKE TAHOE OTTO CUSH INDIGO",
      "Theme": "LAKE TAHOE",
      "Available": 18.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.6531,
      "New WOS": 33.685499923442045,
      "Sales Ratio": 0.0,
      "Order": 4.0,
      "AAO": 22.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "75912230",
      "Description": "SIESTA KEY 102\" BENCH PAD IO STEEL",
      "Theme": "SIESTA KEY",
      "Available": 3.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.28,
      "New WOS": 35.71428571428571,
      "Sales Ratio": 0.0,
      "Order": 7.0,
      "AAO": 10.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77210448",
      "Description": "PLEASANT BAY LOVESEAT CUSHION SUNBRELLA INDIGO",
      "Theme": "PLEASANT BAY",
      "Available": 14.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.6531,
      "New WOS": 33.685499923442045,
      "Sales Ratio": 0.0,
      "Order": 8.0,
      "AAO": 22.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77312406",
      "Description": "LAKE TAHOE CLUB CHAIR CUSHION TERRACOTTA",
      "Theme": "LAKE TAHOE",
      "Available": 11.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.56,
      "New WOS": 33.92857142857142,
      "Sales Ratio": 0.0,
      "Order": 8.0,
      "AAO": 19.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "75612373",
      "Description": "LAKE TAHOE DIN ARM CHR CUSH IO CHARCOAL",
      "Theme": "LAKE TAHOE",
      "Available": 22.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.9331,
      "New WOS": 34.294287857678704,
      "Sales Ratio": 0.0,
      "Order": 10.0,
      "AAO": 32.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "78812902",
      "Description": "P129-KP ZAPOTEC KIDNEY",
      "Theme": "ZAPOTEC",
      "Available": 21.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.9331,
      "New WOS": 34.294287857678704,
      "Sales Ratio": 0.0,
      "Order": 11.0,
      "AAO": 32.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77710448",
      "Description": "PB ARMLESS CHR CUSH INDIGO",
      "Theme": "PLEASANT BAY",
      "Available": 17.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.84,
      "New WOS": 34.523809523809526,
      "Sales Ratio": 0.0,
      "Order": 12.0,
      "AAO": 29.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77412345",
      "Description": "LAKE TAHOE OTTO CUSH SEAGULL",
      "Theme": "LAKE TAHOE",
      "Available": 14.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.7469,
      "New WOS": 34.8105502744678,
      "Sales Ratio": 0.0,
      "Order": 12.0,
      "AAO": 26.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "18902191",
      "Description": "0200-PP-A-YR TP PILLOW PAIR",
      "Theme": "GRACIE",
      "Available": 12.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.7469,
      "New WOS": 34.8105502744678,
      "Sales Ratio": 0.0,
      "Order": 14.0,
      "AAO": 26.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77110446",
      "Description": "PLEASANT BAY  SOFA CUSHION SUNBRELLA INDIGO",
      "Theme": "PLEASANT BAY",
      "Available": 34.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 1.4,
      "New WOS": 34.285714285714285,
      "Sales Ratio": 0.0,
      "Order": 14.0,
      "AAO": 48.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "18903143",
      "Description": "0200-PPBXL-RW TP PILLOW PAIR",
      "Theme": "CRAFTED",
      "Available": 17.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.9331,
      "New WOS": 34.294287857678704,
      "Sales Ratio": 0.0,
      "Order": 15.0,
      "AAO": 32.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "75611701",
      "Description": "MONTECELLO DINING SIDE CHAIR CUSHION MIST",
      "Theme": "MONTECELLO",
      "Available": 33.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 1.4,
      "New WOS": 34.285714285714285,
      "Sales Ratio": 0.0,
      "Order": 15.0,
      "AAO": 48.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "78300464",
      "Description": "LANAI CORNER CUSHION LINDY MINERAL",
      "Theme": "LANAI",
      "Available": 35.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 1.4931,
      "New WOS": 34.1571227647177,
      "Sales Ratio": 0.0,
      "Order": 16.0,
      "AAO": 51.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77410000",
      "Description": "PATMOS OTTO SHORT LINEN",
      "Theme": "PATMOS",
      "Available": 19.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 1.0269,
      "New WOS": 34.08316291751875,
      "Sales Ratio": 0.0,
      "Order": 16.0,
      "AAO": 35.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77210640",
      "Description": "PLEASANT BAY  LOVESEAT CUSHION SUNBRELLA VAPOR",
      "Theme": "PLEASANT BAY",
      "Available": 14.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 0.9331,
      "New WOS": 34.294287857678704,
      "Sales Ratio": 0.0,
      "Order": 18.0,
      "AAO": 32.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77512361",
      "Description": "LAKE TAHOE CHAISE CUSH INDIGO",
      "Theme": "LAKE TAHOE",
      "Available": 24.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 1.2131,
      "New WOS": 34.62204270051933,
      "Sales Ratio": 0.0,
      "Order": 18.0,
      "AAO": 42.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "93302075",
      "Description": "P207-AO TEAL POUF OTTOMAN",
      "Theme": "PALL",
      "Available": 18.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 1.2131,
      "New WOS": 34.62204270051933,
      "Sales Ratio": 0.0,
      "Order": 24.0,
      "AAO": 42.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77810642",
      "Description": "PB WEDGE CUSH VAPOR",
      "Theme": "PLEASANT BAY",
      "Available": 14.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 1.12,
      "New WOS": 33.92857142857142,
      "Sales Ratio": 0.0,
      "Order": 24.0,
      "AAO": 38.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "78811215",
      "Description": "P112-KP LAV PALM MAR KID PILLOW",
      "Theme": "LAVISH PALM MARINE",
      "Available": 66.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 2.6131,
      "New WOS": 34.44185067544296,
      "Sales Ratio": 0.0,
      "Order": 24.0,
      "AAO": 90.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "18902204",
      "Description": "0601-PP-A PILLOW PACK",
      "Theme": "GRACIE",
      "Available": 13.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 1.12,
      "New WOS": 33.92857142857142,
      "Sales Ratio": 0.0,
      "Order": 25.0,
      "AAO": 38.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77510127",
      "Description": "PATMOS CHAISE CUSH LINEN",
      "Theme": "PATMOS",
      "Available": 25.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 1.4931,
      "New WOS": 34.1571227647177,
      "Sales Ratio": 0.0,
      "Order": 26.0,
      "AAO": 51.0,
      "AAOR": 0.0
    },
    {
      "Primary": true,
      "SKU": "78300363",
      "Description": "LANAI CORNER CUSHION LINDY CREAM",
      "Theme": "LANAI",
      "Available": 41.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 2.0531,
      "New WOS": 34.094783498124784,
      "Sales Ratio": 0.0,
      "Order": 29.0,
      "AAO": 70.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77410442",
      "Description": "PLEASANT BAY OTTOMAN CUSHION SUNBRELLA INDIGO",
      "Theme": "PLEASANT BAY",
      "Available": 13.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 1.2131,
      "New WOS": 34.62204270051933,
      "Sales Ratio": 0.0,
      "Order": 29.0,
      "AAO": 42.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77112363",
      "Description": "LAKE TAHOE SUNBRELLA INDIGO SOFA CUSHION",
      "Theme": "LAKE TAHOE",
      "Available": 22.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 1.4931,
      "New WOS": 34.1571227647177,
      "Sales Ratio": 0.0,
      "Order": 29.0,
      "AAO": 51.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77810440",
      "Description": "PB WEDGE CUSH INDIGO",
      "Theme": "PLEASANT BAY",
      "Available": 5.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 1.0269,
      "New WOS": 34.08316291751875,
      "Sales Ratio": 0.0,
      "Order": 30.0,
      "AAO": 35.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77112818",
      "Description": "LB/LKBRZ SOFA CUSH PARCHMENT",
      "Theme": "LAKE BREEZE",
      "Available": 26.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 1.68,
      "New WOS": 34.523809523809526,
      "Sales Ratio": 0.0,
      "Order": 32.0,
      "AAO": 58.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77412814",
      "Description": "LB/LKBRZ OTTO CUSH PARCHMENT",
      "Theme": "LAKE BREEZE",
      "Available": 10.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 1.2131,
      "New WOS": 34.62204270051933,
      "Sales Ratio": 0.0,
      "Order": 32.0,
      "AAO": 42.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "75610646",
      "Description": "PLEASANT BAY DINING CHAIR CUSHION VAPOR",
      "Theme": "PLEASANT BAY",
      "Available": 44.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 2.24,
      "New WOS": 34.375,
      "Sales Ratio": 0.0,
      "Order": 33.0,
      "AAO": 77.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "75612347",
      "Description": "LAKE TAHOE DN ARM CHR CUSH SEAGULL",
      "Theme": "LAKE TAHOE",
      "Available": 31.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 1.8669,
      "New WOS": 34.2814291070759,
      "Sales Ratio": 0.0,
      "Order": 33.0,
      "AAO": 64.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77212810",
      "Description": "LAKE BREEZE LOVESEAT LAF/RAF CUSH PARCHMENT",
      "Theme": "LAKE BREEZE",
      "Available": 12.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 1.3069,
      "New WOS": 34.432626826842146,
      "Sales Ratio": 0.0,
      "Order": 33.0,
      "AAO": 45.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "93302099",
      "Description": "P209-AO OXIDE POUF OTTOMAN",
      "Theme": "PALL",
      "Available": 27.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 1.7731,
      "New WOS": 34.403022954148106,
      "Sales Ratio": 0.0,
      "Order": 34.0,
      "AAO": 61.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77212000",
      "Description": "PATMOS L/S CUSH STEEL",
      "Theme": "PATMOS",
      "Available": 14.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 1.4,
      "New WOS": 34.285714285714285,
      "Sales Ratio": 0.0,
      "Order": 34.0,
      "AAO": 48.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "18902189",
      "Description": "0200-PP-A-YQ TP PILLOW PAIR",
      "Theme": "GRACIE",
      "Available": 15.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 1.4931,
      "New WOS": 34.1571227647177,
      "Sales Ratio": 0.0,
      "Order": 36.0,
      "AAO": 51.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "75512371",
      "Description": "LAKE TAHOE DIN SIDE CHR CUSH IO CHARCOAL",
      "Theme": "LAKE TAHOE",
      "Available": 38.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 2.1469,
      "New WOS": 34.46830313475243,
      "Sales Ratio": 0.0,
      "Order": 36.0,
      "AAO": 74.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77310123",
      "Description": "PATMOS CLUB/SWVL CUSH LIINEN",
      "Theme": "PATMOS",
      "Available": 68.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 3.08,
      "New WOS": 34.41558441558441,
      "Sales Ratio": 0.0,
      "Order": 38.0,
      "AAO": 106.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "18902165",
      "Description": "0200-PP-A-YO TP PILLOW PAIR",
      "Theme": "GRACIE",
      "Available": 11.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 1.4931,
      "New WOS": 34.1571227647177,
      "Sales Ratio": 0.0,
      "Order": 40.0,
      "AAO": 51.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77112349",
      "Description": "LAKE TAHOE SUNBRELLA SEAGULL SOFA CUSHION",
      "Theme": "LAKE TAHOE",
      "Available": 27.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 1.96,
      "New WOS": 34.183673469387756,
      "Sales Ratio": 0.0,
      "Order": 40.0,
      "AAO": 67.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77512816",
      "Description": "LAKE BREEZE SUNBRELLA PARCHMENT CHAISE CUSHION",
      "Theme": "LAKE BREEZE",
      "Available": 26.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 1.96,
      "New WOS": 34.183673469387756,
      "Sales Ratio": 0.0,
      "Order": 41.0,
      "AAO": 67.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77512373",
      "Description": "LAKE TAHOE CHAISE CUSH IO CHARCOAL",
      "Theme": "LAKE TAHOE",
      "Available": 14.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 1.68,
      "New WOS": 34.523809523809526,
      "Sales Ratio": 0.0,
      "Order": 44.0,
      "AAO": 58.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "93302114",
      "Description": "P211-AO SUN BOUCLE ALMOND POUF",
      "Theme": "PALL",
      "Available": 31.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 2.24,
      "New WOS": 34.375,
      "Sales Ratio": 0.0,
      "Order": 46.0,
      "AAO": 77.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77412004",
      "Description": "PATMOS SHORT OTTO CUSH STEEL",
      "Theme": "PATMOS",
      "Available": 26.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 2.1469,
      "New WOS": 34.46830313475243,
      "Sales Ratio": 0.0,
      "Order": 48.0,
      "AAO": 74.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77610446",
      "Description": "PLEASANT BAY LAF/RAF LOVESEAT CUSHION SUNBRELLA IN",
      "Theme": "PLEASANT BAY",
      "Available": 14.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 1.8669,
      "New WOS": 34.2814291070759,
      "Sales Ratio": 0.0,
      "Order": 50.0,
      "AAO": 64.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77510646",
      "Description": "PLEASANT BAY CHAISE CUSHION SUNBRELLA VAPOR",
      "Theme": "PLEASANT BAY",
      "Available": 45.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 2.8931,
      "New WOS": 34.21934948670976,
      "Sales Ratio": 0.0,
      "Order": 54.0,
      "AAO": 99.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77610648",
      "Description": "PLEASANT BAY LAF/RAF LOVESEAT CUSHION SUNBRELLA VA",
      "Theme": "PLEASANT BAY",
      "Available": 26.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 2.4269,
      "New WOS": 34.20000824096584,
      "Sales Ratio": 0.0,
      "Order": 57.0,
      "AAO": 83.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "18902153",
      "Description": "0200-PP-A-YN TP PILLOW PAIR",
      "Theme": "GRACIE",
      "Available": 22.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 2.3331,
      "New WOS": 34.28914320003429,
      "Sales Ratio": 0.0,
      "Order": 58.0,
      "AAO": 80.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77812367",
      "Description": "LAKE TAHOE CLUB CHR CUSH INDIGO",
      "Theme": "LAKE TAHOE",
      "Available": 42.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 2.9869,
      "New WOS": 34.14911781445646,
      "Sales Ratio": 0.0,
      "Order": 60.0,
      "AAO": 102.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "93302087",
      "Description": "P208-AO PEWTER POUF OTTOMAN",
      "Theme": "PALL",
      "Available": 45.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 3.08,
      "New WOS": 34.41558441558441,
      "Sales Ratio": 0.0,
      "Order": 61.0,
      "AAO": 106.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "93302063",
      "Description": "P206-AO INK POUF OTTOMAN",
      "Theme": "PALL",
      "Available": 39.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 2.9869,
      "New WOS": 34.14911781445646,
      "Sales Ratio": 0.0,
      "Order": 63.0,
      "AAO": 102.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77410644",
      "Description": "PLEASANT BAY OTTOMAN CUSHION SUNBRELLA VAPOR",
      "Theme": "PLEASANT BAY",
      "Available": 22.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 2.52,
      "New WOS": 34.12698412698413,
      "Sales Ratio": 0.0,
      "Order": 64.0,
      "AAO": 86.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "78811316",
      "Description": "P113-KP LAV PALM GREEN KID PILLOW",
      "Theme": "LAVISH PALM GREEN",
      "Available": 16.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 2.3331,
      "New WOS": 34.28914320003429,
      "Sales Ratio": 0.0,
      "Order": 64.0,
      "AAO": 80.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77512006",
      "Description": "PATMOS CHAISE CUSH STEEL",
      "Theme": "PATMOS",
      "Available": 24.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 2.6131,
      "New WOS": 34.44185067544296,
      "Sales Ratio": 0.0,
      "Order": 66.0,
      "AAO": 90.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "75612006",
      "Description": "PATMOS DN A/C CUSH STEEL",
      "Theme": "PATMOS",
      "Available": 41.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 3.1731,
      "New WOS": 34.35126532413098,
      "Sales Ratio": 0.0,
      "Order": 68.0,
      "AAO": 109.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77312812",
      "Description": "LAKE BREEZE CLUB/ARMLESS CUSH PARCHMENT",
      "Theme": "LAKE BREEZE",
      "Available": 57.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 3.7331,
      "New WOS": 34.287857276794085,
      "Sales Ratio": 0.0,
      "Order": 71.0,
      "AAO": 128.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "78811518",
      "Description": "P115-KP MADURA NAVY KID PILLOW",
      "Theme": "MADURA NAVY",
      "Available": 34.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 3.08,
      "New WOS": 34.41558441558441,
      "Sales Ratio": 0.0,
      "Order": 72.0,
      "AAO": 106.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77110648",
      "Description": "PLEASANT BAY SOFA CUSHION SUNBRELLA VAPOR",
      "Theme": "PLEASANT BAY",
      "Available": 35.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 3.2669,
      "New WOS": 34.28326548103707,
      "Sales Ratio": 0.0,
      "Order": 77.0,
      "AAO": 112.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77300463",
      "Description": "LANAI CLUB CHAIR CUSHION LINDY MINERAL",
      "Theme": "LANAI",
      "Available": 183.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 7.6531,
      "New WOS": 34.23449321190106,
      "Sales Ratio": 0.0,
      "Order": 79.0,
      "AAO": 262.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "18902141",
      "Description": "0200-PP-A-YM TP PILLOW PAIR",
      "Theme": "GRACIE",
      "Available": 29.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 3.1731,
      "New WOS": 34.35126532413098,
      "Sales Ratio": 0.0,
      "Order": 80.0,
      "AAO": 109.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "75512345",
      "Description": "LAKE TAHOE SIDE CHR CUSH SEAGULL",
      "Theme": "LAKE TAHOE",
      "Available": 52.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 3.92,
      "New WOS": 34.183673469387756,
      "Sales Ratio": 0.0,
      "Order": 82.0,
      "AAO": 134.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77412371",
      "Description": "LAKE TAHOE OTTOMAN CUSH IO CHARCOAL",
      "Theme": "LAKE TAHOE",
      "Available": 11.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 2.7069,
      "New WOS": 34.35664413166352,
      "Sales Ratio": 0.0,
      "Order": 82.0,
      "AAO": 93.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "78911318",
      "Description": "P113-TP LAV PALM GREEN PAIR OF PILLOWS",
      "Theme": "LAVISH PALM GREEN",
      "Available": 37.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 3.5469,
      "New WOS": 34.39623333051397,
      "Sales Ratio": 0.0,
      "Order": 85.0,
      "AAO": 122.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77812343",
      "Description": "LAKE TAHOE CLUB CHR CUSH SEAGULL",
      "Theme": "LAKE TAHOE",
      "Available": 46.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 4.0131,
      "New WOS": 34.38738132615684,
      "Sales Ratio": 0.0,
      "Order": 92.0,
      "AAO": 138.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "78911217",
      "Description": "P112-TP LAV PALM MAR PAIR OF PILLOWS",
      "Theme": "LAVISH PALM MARINE",
      "Available": 38.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 3.92,
      "New WOS": 34.183673469387756,
      "Sales Ratio": 0.0,
      "Order": 96.0,
      "AAO": 134.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "75607992",
      "Description": "RIVA DN ARM CHAIR CUSHION WHITE",
      "Theme": "RIVA",
      "Available": 47.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 4.2931,
      "New WOS": 34.24099135822599,
      "Sales Ratio": 0.0,
      "Order": 100.0,
      "AAO": 147.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77112375",
      "Description": "LAKE TAHOE SOFA CUSH IO CHARCOAL",
      "Theme": "LAKE TAHOE",
      "Available": 32.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 4.0131,
      "New WOS": 34.38738132615684,
      "Sales Ratio": 0.0,
      "Order": 106.0,
      "AAO": 138.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77512347",
      "Description": "LAKE TAHOE CHAISE CUSH SEAGULL",
      "Theme": "LAKE TAHOE",
      "Available": 20.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 3.7331,
      "New WOS": 34.287857276794085,
      "Sales Ratio": 0.0,
      "Order": 108.0,
      "AAO": 128.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77112008",
      "Description": "PATMOS SOFA CUSH STEEL",
      "Theme": "PATMOS",
      "Available": 38.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 4.3869,
      "New WOS": 34.192710114203656,
      "Sales Ratio": 0.0,
      "Order": 112.0,
      "AAO": 150.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "93302102",
      "Description": "P210-AO ENDURANCE RUST POUF",
      "Theme": "PALL",
      "Available": 46.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 4.76,
      "New WOS": 34.2436974789916,
      "Sales Ratio": 0.0,
      "Order": 117.0,
      "AAO": 163.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77310440",
      "Description": "PLEASANT BAY CLUB CHAIR CUSHION SUNBRELLA INDIGO",
      "Theme": "PLEASANT BAY",
      "Available": 74.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 5.7869,
      "New WOS": 34.215210216177915,
      "Sales Ratio": 0.0,
      "Order": 124.0,
      "AAO": 198.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "75512004",
      "Description": "PATMOS DN S/C CUSH STEEL",
      "Theme": "PATMOS",
      "Available": 96.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 6.5331,
      "New WOS": 34.286938819243545,
      "Sales Ratio": 0.0,
      "Order": 128.0,
      "AAO": 224.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77510444",
      "Description": "PLEASANT BAY CHAISE CUSHION SUNBRELLA INDIGO",
      "Theme": "PLEASANT BAY",
      "Available": 23.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 4.48,
      "New WOS": 34.375,
      "Sales Ratio": 0.0,
      "Order": 131.0,
      "AAO": 154.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "78911510",
      "Description": "P115-TP MADURA NAVY PAIR OF PILLOWS",
      "Theme": "MADURA NAVY",
      "Available": 70.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 5.88,
      "New WOS": 34.35374149659864,
      "Sales Ratio": 0.0,
      "Order": 132.0,
      "AAO": 202.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77307998",
      "Description": "RIVA CLUB CHAIR CUSHION WHITE",
      "Theme": "RIVA",
      "Available": 42.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 5.32,
      "New WOS": 34.21052631578947,
      "Sales Ratio": 0.0,
      "Order": 140.0,
      "AAO": 182.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "75612816",
      "Description": "LAKE BREEZE DN/SWL CUSH PARCHMENT",
      "Theme": "LAKE BREEZE",
      "Available": 47.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 5.6,
      "New WOS": 34.285714285714285,
      "Sales Ratio": 0.0,
      "Order": 145.0,
      "AAO": 192.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77307695",
      "Description": "RIVA CLUB CHAIR CUSHION DOVE",
      "Theme": "RIVA",
      "Available": 35.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 5.5069,
      "New WOS": 34.32057963645608,
      "Sales Ratio": 0.0,
      "Order": 154.0,
      "AAO": 189.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "12612241",
      "Description": "1224-56 COCKTAIL OTTOMAN",
      "Theme": "BEDFORD PARK",
      "Available": 64.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 6.3469,
      "New WOS": 34.34747672091888,
      "Sales Ratio": 0.0,
      "Order": 154.0,
      "AAO": 218.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77310642",
      "Description": "PLEASANT BAY CLUB CHAIR CUSHION SUNBRELLA VAPOR",
      "Theme": "PLEASANT BAY",
      "Available": 76.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 7.3731,
      "New WOS": 34.31392494337524,
      "Sales Ratio": 0.0,
      "Order": 177.0,
      "AAO": 253.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77312379",
      "Description": "LAKE TAHOE CLUB CHAIR CUSH IO CHARCOAL",
      "Theme": "LAKE TAHOE",
      "Available": 74.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 7.84,
      "New WOS": 34.31122448979592,
      "Sales Ratio": 0.0,
      "Order": 195.0,
      "AAO": 269.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "77312002",
      "Description": "PATMOS CLUB/SWVL CUSH STEEL",
      "Theme": "PATMOS",
      "Available": 118.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 12.7869,
      "New WOS": 34.253806630223124,
      "Sales Ratio": 0.0,
      "Order": 320.0,
      "AAO": 438.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "75610444",
      "Description": "PLEASANT BAY DINING CHAIR CUSHION INDIGO",
      "Theme": "PLEASANT BAY",
      "Available": 138.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 13.5331,
      "New WOS": 34.28630542891134,
      "Sales Ratio": 0.0,
      "Order": 326.0,
      "AAO": 464.0,
      "AAOR": 0.0
    },
    {
      "Primary": false,
      "SKU": "75607699",
      "Description": "RIVA DN ARM CHAIR CUSHION DOVE",
      "Theme": "RIVA",
      "Available": 128.0,
      "ExPr Avail": 0.0,
      "ExPr AAO": 0.0,
      "Weekly Sales": 19.2269,
      "New WOS": 34.27489610909715,
      "Sales Ratio": 0.0,
      "Order": 531.0,
      "AAO": 659.0,
      "AAOR": 0.0
    }
  ],
  "details": [
    {
      "SKU": "77400465",
      "Product ID (PDM)": 347609.0,
      "Alias": "HMRI P332",
      "FOB": "GUNTOWN",
      "Color": "MINERAL",
      "Factory Color": "MINERAL",
      "Theme": "LANAI",
      "Description": "LANAI OTTOMAN CUSHION LINDY MINERAL",
      "Family": "0046",
      "Cube": 8.71,
      "Avg Daily Sales": 0.0533,
      "Weekly Sales": 0.3731,
      "Total Sales": 4.0,
      "QOH": 17.0,
      "Inbound": 0.0,
      "Available": 16.0,
      "Weeks of Stock": 42.8571,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 12.8,
      "Order Point": 12.8,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 42.8571,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 10.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 16.0,
      "EOL AVAIL": 15.0,
      "Avail After Order": 16.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77301251",
      "Product ID (PDM)": 197385.0,
      "Alias": "HMRI 313",
      "FOB": "GUNTOWN",
      "Color": "SILK",
      "Factory Color": "SILK",
      "Theme": "LAKE COMO",
      "Description": "LK COMO CLB CHR CUSH SILK",
      "Family": "0125",
      "Cube": 9.1,
      "Avg Daily Sales": 0.0,
      "Weekly Sales": 0.0,
      "Total Sales": 0.0,
      "QOH": 15.0,
      "Inbound": 20.0,
      "Available": 35.0,
      "Weeks of Stock": 0.0,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 0.0,
      "Order Point": 0.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 0.0,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 2.0,
      "# of Skus in Carton (PDM)": 2.0,
      "Avail Today": 15.0,
      "EOL AVAIL": 55.0,
      "Avail After Order": 35.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.28,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77401253",
      "Product ID (PDM)": 16131.0,
      "Alias": "HMRI 313",
      "FOB": "GUNTOWN",
      "Color": "SILK",
      "Factory Color": "SILK",
      "Theme": "LAKE COMO",
      "Description": "LK COMO OTTO CUSH SILK",
      "Family": "0125",
      "Cube": 3.0,
      "Avg Daily Sales": 0.0,
      "Weekly Sales": 0.0,
      "Total Sales": 0.0,
      "QOH": 17.0,
      "Inbound": 20.0,
      "Available": 37.0,
      "Weeks of Stock": 0.0,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 0.0,
      "Order Point": 0.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 0.0,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 2.0,
      "# of Skus in Carton (PDM)": 2.0,
      "Avail Today": 17.0,
      "EOL AVAIL": 57.0,
      "Avail After Order": 37.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.17,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "78401266",
      "Product ID (PDM)": 118451.0,
      "Alias": "HMRI 313",
      "FOB": "GUNTOWN",
      "Color": "MALT",
      "Factory Color": "MALT",
      "Theme": "LAKE COMO",
      "Description": "LK COMO ARMLESS CHR CUSH MALT",
      "Family": "0126",
      "Cube": 9.5,
      "Avg Daily Sales": 0.0,
      "Weekly Sales": 0.0,
      "Total Sales": 0.0,
      "QOH": 23.0,
      "Inbound": 20.0,
      "Available": 42.0,
      "Weeks of Stock": 0.0,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 0.0,
      "Order Point": 0.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 0.0,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 2.0,
      "# of Skus in Carton (PDM)": 2.0,
      "Avail Today": 22.0,
      "EOL AVAIL": 62.0,
      "Avail After Order": 42.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.28,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77301504",
      "Product ID (PDM)": 238719.0,
      "Alias": "HMRI 313",
      "FOB": "GUNTOWN",
      "Color": "COCONUT",
      "Factory Color": "COCONUT",
      "Theme": "LAKE COMO",
      "Description": "LK COMO CLB CHR CUSH COCONUT",
      "Family": "0150",
      "Cube": 9.15,
      "Avg Daily Sales": 0.0,
      "Weekly Sales": 0.0,
      "Total Sales": 0.0,
      "QOH": 9.0,
      "Inbound": 0.0,
      "Available": 9.0,
      "Weeks of Stock": 0.0,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 0.0,
      "Order Point": 0.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 0.0,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 2.0,
      "# of Skus in Carton (PDM)": 2.0,
      "Avail Today": 9.0,
      "EOL AVAIL": 9.0,
      "Avail After Order": 9.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.28,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77401506",
      "Product ID (PDM)": 238720.0,
      "Alias": "HMRI 313",
      "FOB": "GUNTOWN",
      "Color": "COCONUT",
      "Factory Color": "COCONUT",
      "Theme": "LAKE COMO",
      "Description": "LK COMO OTTO CUSH COCONUT",
      "Family": "0150",
      "Cube": 3.16,
      "Avg Daily Sales": 0.0,
      "Weekly Sales": 0.0,
      "Total Sales": 0.0,
      "QOH": 14.0,
      "Inbound": 0.0,
      "Available": 14.0,
      "Weeks of Stock": 0.0,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 0.0,
      "Order Point": 0.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 0.0,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 2.0,
      "# of Skus in Carton (PDM)": 2.0,
      "Avail Today": 14.0,
      "EOL AVAIL": 14.0,
      "Avail After Order": 14.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.17,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77301605",
      "Product ID (PDM)": 298310.0,
      "Alias": "HMRI 313",
      "FOB": "GUNTOWN",
      "Color": "TERACOTA",
      "Factory Color": "TERACOTA",
      "Theme": "LAKE COMO",
      "Description": "LK COMO CLUB CHAIR CUSH SUNBRELLA TERRACOTTA",
      "Family": "0160",
      "Cube": 9.0,
      "Avg Daily Sales": 0.0,
      "Weekly Sales": 0.0,
      "Total Sales": 0.0,
      "QOH": 17.0,
      "Inbound": 0.0,
      "Available": 17.0,
      "Weeks of Stock": 0.0,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 0.0,
      "Order Point": 0.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 0.0,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 17.0,
      "EOL AVAIL": 17.0,
      "Avail After Order": 17.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77301706",
      "Product ID (PDM)": 313250.0,
      "Alias": "HMRI 313",
      "FOB": "GUNTOWN",
      "Color": "MIST",
      "Factory Color": "MIST",
      "Theme": "LAKE COMO",
      "Description": "LK COMO CLUB CHAIR SUNBRELLA MIST",
      "Family": "0170",
      "Cube": 9.0,
      "Avg Daily Sales": 0.0,
      "Weekly Sales": 0.0,
      "Total Sales": 0.0,
      "QOH": 38.0,
      "Inbound": 0.0,
      "Available": 38.0,
      "Weeks of Stock": 0.0,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 0.0,
      "Order Point": 0.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 0.0,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 38.0,
      "EOL AVAIL": 38.0,
      "Avail After Order": 38.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77401708",
      "Product ID (PDM)": 313251.0,
      "Alias": "HMRI 313",
      "FOB": "GUNTOWN",
      "Color": "MIST",
      "Factory Color": "MIST",
      "Theme": "LAKE COMO",
      "Description": "LK COMO OTTOMAN SUNBRELLA MIST",
      "Family": "0170",
      "Cube": 3.1,
      "Avg Daily Sales": 0.0,
      "Weekly Sales": 0.0,
      "Total Sales": 0.0,
      "QOH": 12.0,
      "Inbound": 0.0,
      "Available": 12.0,
      "Weeks of Stock": 0.0,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 0.0,
      "Order Point": 0.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 0.0,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 12.0,
      "EOL AVAIL": 12.0,
      "Avail After Order": 12.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "78401709",
      "Product ID (PDM)": 313252.0,
      "Alias": "HMRI 313",
      "FOB": "GUNTOWN",
      "Color": "MIST",
      "Factory Color": "MIST",
      "Theme": "LAKE COMO",
      "Description": "LK COMO ARMLESS CHAIR SUNBRELLA MIST",
      "Family": "0170",
      "Cube": 10.0,
      "Avg Daily Sales": 0.04,
      "Weekly Sales": 0.28,
      "Total Sales": 3.0,
      "QOH": 23.0,
      "Inbound": 0.0,
      "Available": 23.0,
      "Weeks of Stock": 82.1429,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 9.6,
      "Order Point": 9.6,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 82.1429,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 23.0,
      "EOL AVAIL": 23.0,
      "Avail After Order": 23.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "18902216",
      "Product ID (PDM)": 338293.0,
      "Alias": "HMRI APOLLO GUNMETAL",
      "FOB": "GUNTOWN",
      "Color": "GUNMETAL",
      "Factory Color": "GUNMETAL",
      "Theme": "GRACIE",
      "Description": "0200-PP-A-YJ TP PILLOW PAIR",
      "Family": "0221",
      "Cube": 2.77,
      "Avg Daily Sales": 0.0133,
      "Weekly Sales": 0.0931,
      "Total Sales": 1.0,
      "QOH": 11.0,
      "Inbound": 0.0,
      "Available": 11.0,
      "Weeks of Stock": 117.8571,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 3.2,
      "Order Point": 3.2,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 117.8571,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 6.0,
      "# of Skus in Carton (PDM)": 6.0,
      "Avail Today": 11.0,
      "EOL AVAIL": 11.0,
      "Avail After Order": 11.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.1,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "18903155",
      "Product ID (PDM)": 313613.0,
      "Alias": "HMRI CLARENDON TAPESTRY",
      "FOB": "GUNTOWN",
      "Color": "TAPESTRY",
      "Factory Color": "TAPESTRY",
      "Theme": "TRENDOME",
      "Description": "0200-PPBXL-SQ TP PILLOW PAIR",
      "Family": "0315",
      "Cube": 3.01,
      "Avg Daily Sales": 0.0,
      "Weekly Sales": 0.0,
      "Total Sales": 0.0,
      "QOH": 13.0,
      "Inbound": 0.0,
      "Available": 13.0,
      "Weeks of Stock": 0.0,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 0.0,
      "Order Point": 0.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 0.0,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 6.0,
      "# of Skus in Carton (PDM)": 6.0,
      "Avail Today": 13.0,
      "EOL AVAIL": 13.0,
      "Avail After Order": 13.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 2.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "75610127",
      "Product ID (PDM)": 184909.0,
      "Alias": "HMRI 302",
      "FOB": "GUNTOWN",
      "Color": "LINEN",
      "Factory Color": "LINEN",
      "Theme": "PATMOS",
      "Description": "PATMOS DN A/C CUSH LINEN",
      "Family": "1012",
      "Cube": 1.07,
      "Avg Daily Sales": 0.1067,
      "Weekly Sales": 0.7469,
      "Total Sales": 8.0,
      "QOH": 40.0,
      "Inbound": 0.0,
      "Available": 36.0,
      "Weeks of Stock": 48.2143,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 25.6,
      "Order Point": 25.6,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 53.5714,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 30.0,
      "#/Box": 10.0,
      "# of Skus in Carton (PDM)": 10.0,
      "Avail Today": 40.0,
      "EOL AVAIL": 32.0,
      "Avail After Order": 36.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.04,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77110129",
      "Product ID (PDM)": 18276.0,
      "Alias": "HMRI 302",
      "FOB": "GUNTOWN",
      "Color": "LINEN",
      "Factory Color": "LINEN",
      "Theme": "PATMOS",
      "Description": "PATMOS SOFA CUSH LINEN",
      "Family": "1012",
      "Cube": 22.96,
      "Avg Daily Sales": 0.1333,
      "Weekly Sales": 0.9331,
      "Total Sales": 10.0,
      "QOH": 41.0,
      "Inbound": 0.0,
      "Available": 36.0,
      "Weeks of Stock": 38.5714,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 32.0,
      "Order Point": 32.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 42.8571,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 40.0,
      "EOL AVAIL": 31.0,
      "Avail After Order": 36.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.85,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77210121",
      "Product ID (PDM)": 52601.0,
      "Alias": "HMRI 302",
      "FOB": "GUNTOWN",
      "Color": "LINEN",
      "Factory Color": "LINEN",
      "Theme": "PATMOS",
      "Description": "PATMOS L/S CUSH LINEN",
      "Family": "1012",
      "Cube": 15.78,
      "Avg Daily Sales": 0.0533,
      "Weekly Sales": 0.3731,
      "Total Sales": 4.0,
      "QOH": 13.0,
      "Inbound": 0.0,
      "Available": 13.0,
      "Weeks of Stock": 34.8214,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 12.8,
      "Order Point": 12.8,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 34.8214,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 13.0,
      "EOL AVAIL": 13.0,
      "Avail After Order": 13.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.64,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77710640",
      "Product ID (PDM)": 232397.0,
      "Alias": "HMRI 304",
      "FOB": "GUNTOWN",
      "Color": "VAPOR",
      "Factory Color": "VAPOR",
      "Theme": "PLEASANT BAY",
      "Description": "PB ARMLESS CHR CUSH VAPOR",
      "Family": "1064",
      "Cube": 9.01,
      "Avg Daily Sales": 0.0533,
      "Weekly Sales": 0.3731,
      "Total Sales": 4.0,
      "QOH": 9.0,
      "Inbound": 11.0,
      "Available": 18.0,
      "Weeks of Stock": 48.2143,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 12.8,
      "Order Point": 12.8,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 37.5,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 7.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 14.0,
      "EOL AVAIL": 27.0,
      "Avail After Order": 18.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "75911012",
      "Product ID (PDM)": 242370.0,
      "Alias": "HMRI 303",
      "FOB": "GUNTOWN",
      "Color": "TWINE",
      "Factory Color": "TWINE",
      "Theme": "SIESTA KEY",
      "Description": "SIESTA KEY 102\"  BENCH PAD IO TWINE",
      "Family": "1101",
      "Cube": 3.36,
      "Avg Daily Sales": 0.0,
      "Weekly Sales": 0.0,
      "Total Sales": 0.0,
      "QOH": 11.0,
      "Inbound": 0.0,
      "Available": 11.0,
      "Weeks of Stock": 0.0,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 0.0,
      "Order Point": 0.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 0.0,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 20.0,
      "# of Skus in Carton (PDM)": 20.0,
      "Avail Today": 11.0,
      "EOL AVAIL": 11.0,
      "Avail After Order": 11.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.2,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "75911024",
      "Product ID (PDM)": 242371.0,
      "Alias": "HMRI 303",
      "FOB": "GUNTOWN",
      "Color": "TWINE",
      "Factory Color": "TWINE",
      "Theme": "SIESTA KEY",
      "Description": "SIESTA KEY 76' BENCH PAD IO TWINE",
      "Family": "1102",
      "Cube": 2.54,
      "Avg Daily Sales": 0.0133,
      "Weekly Sales": 0.0931,
      "Total Sales": 1.0,
      "QOH": 9.0,
      "Inbound": 0.0,
      "Available": 8.0,
      "Weeks of Stock": 85.7143,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 3.2,
      "Order Point": 3.2,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 96.4286,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 1.0,
      "#/Box": 20.0,
      "# of Skus in Carton (PDM)": 20.0,
      "Avail Today": 9.0,
      "EOL AVAIL": 7.0,
      "Avail After Order": 8.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.15,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "75511709",
      "Product ID (PDM)": 176359.0,
      "Alias": "HMRI 312",
      "FOB": "GUNTOWN",
      "Color": "MIST",
      "Factory Color": "MIST",
      "Theme": "MONTECELLO",
      "Description": "MONTECELLO DINING ARM CHAIR CUSHION PREMIER MIST",
      "Family": "1170",
      "Cube": 1.1,
      "Avg Daily Sales": 0.1333,
      "Weekly Sales": 0.9331,
      "Total Sales": 10.0,
      "QOH": 41.0,
      "Inbound": 0.0,
      "Available": 39.0,
      "Weeks of Stock": 41.7857,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 32.0,
      "Order Point": 32.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 43.9286,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 10.0,
      "# of Skus in Carton (PDM)": 10.0,
      "Avail Today": 41.0,
      "EOL AVAIL": 37.0,
      "Avail After Order": 39.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 1.1,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77511701",
      "Product ID (PDM)": 339384.0,
      "Alias": "HMRI 312",
      "FOB": "GUNTOWN",
      "Color": "MIST",
      "Factory Color": "MIST",
      "Theme": "MONTECELLO",
      "Description": "MONTECELLO CHAISE CUSHION MIST",
      "Family": "1170",
      "Cube": 11.48,
      "Avg Daily Sales": 0.0133,
      "Weekly Sales": 0.0931,
      "Total Sales": 1.0,
      "QOH": 17.0,
      "Inbound": 0.0,
      "Available": 16.0,
      "Weeks of Stock": 171.4286,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 3.2,
      "Order Point": 3.2,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 182.1429,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 4.0,
      "# of Skus in Carton (PDM)": 4.0,
      "Avail Today": 17.0,
      "EOL AVAIL": 15.0,
      "Avail After Order": 16.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77212341",
      "Product ID (PDM)": 223912.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "SEAGULL",
      "Factory Color": "SEAGULL",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE SUNBRELLA SEAGULL LOVESEAT CUSHION",
      "Family": "1234",
      "Cube": 15.78,
      "Avg Daily Sales": 0.0533,
      "Weekly Sales": 0.3731,
      "Total Sales": 4.0,
      "QOH": 13.0,
      "Inbound": 0.0,
      "Available": 13.0,
      "Weeks of Stock": 34.8214,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 12.8,
      "Order Point": 12.8,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 34.8214,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 13.0,
      "EOL AVAIL": 13.0,
      "Avail After Order": 13.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.64,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "75512369",
      "Product ID (PDM)": 223934.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "INDIGO",
      "Factory Color": "INDIGO",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE SIDE CHR CUSH INDIGO",
      "Family": "1236",
      "Cube": 1.1,
      "Avg Daily Sales": 0.16,
      "Weekly Sales": 1.12,
      "Total Sales": 12.0,
      "QOH": 55.0,
      "Inbound": 0.0,
      "Available": 51.0,
      "Weeks of Stock": 45.5357,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 38.4,
      "Order Point": 38.4,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 49.1071,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 10.0,
      "# of Skus in Carton (PDM)": 10.0,
      "Avail Today": 55.0,
      "EOL AVAIL": 47.0,
      "Avail After Order": 51.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.04,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "75612361",
      "Product ID (PDM)": 223935.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "INDIGO",
      "Factory Color": "INDIGO",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE DIN ARM CHR CUSH",
      "Family": "1236",
      "Cube": 1.1,
      "Avg Daily Sales": 0.0533,
      "Weekly Sales": 0.3731,
      "Total Sales": 4.0,
      "QOH": 35.0,
      "Inbound": 0.0,
      "Available": 31.0,
      "Weeks of Stock": 83.0357,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 12.8,
      "Order Point": 12.8,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 93.75,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 10.0,
      "# of Skus in Carton (PDM)": 10.0,
      "Avail Today": 35.0,
      "EOL AVAIL": 27.0,
      "Avail After Order": 31.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.04,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77212365",
      "Product ID (PDM)": 223932.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "INDIGO",
      "Factory Color": "INDIGO",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE SUNBRELLA INDIGO LOVESEAT CUSHION",
      "Family": "1236",
      "Cube": 15.78,
      "Avg Daily Sales": 0.0533,
      "Weekly Sales": 0.3731,
      "Total Sales": 4.0,
      "QOH": 16.0,
      "Inbound": 0.0,
      "Available": 15.0,
      "Weeks of Stock": 40.1786,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 12.8,
      "Order Point": 12.8,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 42.8571,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 16.0,
      "EOL AVAIL": 14.0,
      "Avail After Order": 15.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.64,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77212377",
      "Product ID (PDM)": 248268.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "CHARCOAL",
      "Factory Color": "CHARCOAL",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE LOVESEAT CUSH IO CHARCOAL",
      "Family": "1237",
      "Cube": 15.79,
      "Avg Daily Sales": 0.0267,
      "Weekly Sales": 0.1869,
      "Total Sales": 2.0,
      "QOH": 16.0,
      "Inbound": 0.0,
      "Available": 15.0,
      "Weeks of Stock": 80.3571,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 6.4,
      "Order Point": 6.4,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 85.7143,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 16.0,
      "EOL AVAIL": 14.0,
      "Avail After Order": 15.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.64,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "75512408",
      "Product ID (PDM)": 339783.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "TERRACOTTA",
      "Factory Color": "TERRACOTTA",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE DINING SIDE CHAIR CUSHION TERRACOTTA",
      "Family": "1240",
      "Cube": 1.07,
      "Avg Daily Sales": 0.0,
      "Weekly Sales": 0.0,
      "Total Sales": 0.0,
      "QOH": 16.0,
      "Inbound": 0.0,
      "Available": 16.0,
      "Weeks of Stock": 0.0,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 0.0,
      "Order Point": 0.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 0.0,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 10.0,
      "# of Skus in Carton (PDM)": 10.0,
      "Avail Today": 16.0,
      "EOL AVAIL": 16.0,
      "Avail After Order": 16.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "75612400",
      "Product ID (PDM)": 339786.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "TERRACOTTA",
      "Factory Color": "TERRACOTTA",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE DINING ARM CHAIR CUSHION TERRACOTTA",
      "Family": "1240",
      "Cube": 1.07,
      "Avg Daily Sales": 0.0,
      "Weekly Sales": 0.0,
      "Total Sales": 0.0,
      "QOH": 20.0,
      "Inbound": 0.0,
      "Available": 20.0,
      "Weeks of Stock": 0.0,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 0.0,
      "Order Point": 0.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 0.0,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 10.0,
      "# of Skus in Carton (PDM)": 10.0,
      "Avail Today": 20.0,
      "EOL AVAIL": 20.0,
      "Avail After Order": 20.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77112402",
      "Product ID (PDM)": 339788.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "TERRACOTTA",
      "Factory Color": "TERRACOTTA",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE SOFA CUSHION TERRACOTTA",
      "Family": "1240",
      "Cube": 22.96,
      "Avg Daily Sales": 0.0267,
      "Weekly Sales": 0.1869,
      "Total Sales": 2.0,
      "QOH": 8.0,
      "Inbound": 0.0,
      "Available": 7.0,
      "Weeks of Stock": 37.5,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 6.4,
      "Order Point": 6.4,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 37.5,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 7.0,
      "EOL AVAIL": 6.0,
      "Avail After Order": 7.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77212404",
      "Product ID (PDM)": 339791.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "TERRACOTTA",
      "Factory Color": "TERRACOTTA",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE LOVESEAT CUSHION TERRACOTTA",
      "Family": "1240",
      "Cube": 15.79,
      "Avg Daily Sales": 0.0133,
      "Weekly Sales": 0.0931,
      "Total Sales": 1.0,
      "QOH": 5.0,
      "Inbound": 0.0,
      "Available": 5.0,
      "Weeks of Stock": 53.5714,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 3.2,
      "Order Point": 3.2,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 53.5714,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 5.0,
      "EOL AVAIL": 5.0,
      "Avail After Order": 5.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77412408",
      "Product ID (PDM)": 339798.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "TERRACOTTA",
      "Factory Color": "TERRACOTTA",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE OTTOMAN CUSHION TERRACOTTA",
      "Family": "1240",
      "Cube": 7.18,
      "Avg Daily Sales": 0.0133,
      "Weekly Sales": 0.0931,
      "Total Sales": 1.0,
      "QOH": 5.0,
      "Inbound": 0.0,
      "Available": 5.0,
      "Weeks of Stock": 53.5714,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 3.2,
      "Order Point": 3.2,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 53.5714,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 5.0,
      "EOL AVAIL": 5.0,
      "Avail After Order": 5.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77512400",
      "Product ID (PDM)": 339801.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "TERRACOTTA",
      "Factory Color": "TERRACOTTA",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE CHAISE CUSHION TERRACOTTA",
      "Family": "1240",
      "Cube": 9.19,
      "Avg Daily Sales": 0.0,
      "Weekly Sales": 0.0,
      "Total Sales": 0.0,
      "QOH": 10.0,
      "Inbound": 0.0,
      "Available": 10.0,
      "Weeks of Stock": 0.0,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 0.0,
      "Order Point": 0.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 0.0,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 5.0,
      "# of Skus in Carton (PDM)": 5.0,
      "Avail Today": 10.0,
      "EOL AVAIL": 10.0,
      "Avail After Order": 10.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "75512509",
      "Product ID (PDM)": 339784.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "BUTTERCUP",
      "Factory Color": "BUTTERCUP",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE DINING SIDE CHAIR CUSHION BUTTERCUP",
      "Family": "1250",
      "Cube": 1.07,
      "Avg Daily Sales": 0.0,
      "Weekly Sales": 0.0,
      "Total Sales": 0.0,
      "QOH": 20.0,
      "Inbound": 0.0,
      "Available": 20.0,
      "Weeks of Stock": 0.0,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 0.0,
      "Order Point": 0.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 0.0,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 10.0,
      "# of Skus in Carton (PDM)": 10.0,
      "Avail Today": 20.0,
      "EOL AVAIL": 20.0,
      "Avail After Order": 20.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "75612501",
      "Product ID (PDM)": 339787.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "BUTTERCUP",
      "Factory Color": "BUTTERCUP",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE DINING ARM CHAIR CUSHION BUTTERCUP",
      "Family": "1250",
      "Cube": 1.07,
      "Avg Daily Sales": 0.0,
      "Weekly Sales": 0.0,
      "Total Sales": 0.0,
      "QOH": 12.0,
      "Inbound": 0.0,
      "Available": 12.0,
      "Weeks of Stock": 0.0,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 0.0,
      "Order Point": 0.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 0.0,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 10.0,
      "# of Skus in Carton (PDM)": 10.0,
      "Avail Today": 12.0,
      "EOL AVAIL": 12.0,
      "Avail After Order": 12.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77112503",
      "Product ID (PDM)": 339789.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "BUTTERCUP",
      "Factory Color": "BUTTERCUP",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE SOFA CUSHION BUTTERCUP",
      "Family": "1250",
      "Cube": 22.96,
      "Avg Daily Sales": 0.0,
      "Weekly Sales": 0.0,
      "Total Sales": 0.0,
      "QOH": 5.0,
      "Inbound": 0.0,
      "Available": 5.0,
      "Weeks of Stock": 0.0,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 0.0,
      "Order Point": 0.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 0.0,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 5.0,
      "EOL AVAIL": 5.0,
      "Avail After Order": 5.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77212505",
      "Product ID (PDM)": 339792.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "BUTTERCUP",
      "Factory Color": "BUTTERCUP",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE LOVESEAT CUSHION  BUTTERCUP",
      "Family": "1250",
      "Cube": 15.79,
      "Avg Daily Sales": 0.0,
      "Weekly Sales": 0.0,
      "Total Sales": 0.0,
      "QOH": 5.0,
      "Inbound": 0.0,
      "Available": 5.0,
      "Weeks of Stock": 0.0,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 0.0,
      "Order Point": 0.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 0.0,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 5.0,
      "EOL AVAIL": 5.0,
      "Avail After Order": 5.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77312507",
      "Product ID (PDM)": 339795.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "BUTTERCUP",
      "Factory Color": "BUTTERCUP",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE CLUB CHAIR CUSHION BUTTERCUP",
      "Family": "1250",
      "Cube": 8.71,
      "Avg Daily Sales": 0.0267,
      "Weekly Sales": 0.1869,
      "Total Sales": 2.0,
      "QOH": 9.0,
      "Inbound": 0.0,
      "Available": 9.0,
      "Weeks of Stock": 48.2143,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 6.4,
      "Order Point": 6.4,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 48.2143,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 9.0,
      "EOL AVAIL": 9.0,
      "Avail After Order": 9.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77512501",
      "Product ID (PDM)": 339802.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "BUTTERCUP",
      "Factory Color": "BUTTERCUP",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE CHAISE CUSHION BUTTERCUP",
      "Family": "1250",
      "Cube": 9.19,
      "Avg Daily Sales": 0.0,
      "Weekly Sales": 0.0,
      "Total Sales": 0.0,
      "QOH": 6.0,
      "Inbound": 0.0,
      "Available": 6.0,
      "Weeks of Stock": 0.0,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 0.0,
      "Order Point": 0.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 0.0,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 0.0,
      "Order": 0.0,
      "L_Order": 0.0,
      "Store QOH": 0.0,
      "#/Box": 5.0,
      "# of Skus in Carton (PDM)": 5.0,
      "Avail Today": 6.0,
      "EOL AVAIL": 6.0,
      "Avail After Order": 6.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "78312813",
      "Product ID (PDM)": 216166.0,
      "Alias": "HMRI 315",
      "FOB": "GUNTOWN",
      "Color": "PARCHMENT",
      "Factory Color": "PARCHMENT",
      "Theme": "LAKE BREEZE",
      "Description": "LAKE BREEZE WEDGE CUSH PARCHMENT",
      "Family": "1281",
      "Cube": 15.79,
      "Avg Daily Sales": 0.0267,
      "Weekly Sales": 0.1869,
      "Total Sales": 2.0,
      "QOH": 6.0,
      "Inbound": 0.0,
      "Available": 5.0,
      "Weeks of Stock": 26.7857,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 6.4,
      "Order Point": 6.4,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 32.1429,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 1.0,
      "Order": 1.0,
      "L_Order": 1.0,
      "Store QOH": 0.0,
      "#/Box": 2.0,
      "# of Skus in Carton (PDM)": 2.0,
      "Avail Today": 6.0,
      "EOL AVAIL": 4.0,
      "Avail After Order": 6.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.64,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "18902177",
      "Product ID (PDM)": 337259.0,
      "Alias": "HMRI APOLLO AUBERGINE",
      "FOB": "GUNTOWN",
      "Color": "AUBERGINE",
      "Factory Color": "AUBERGINE",
      "Theme": "GRACIE",
      "Description": "0200-PP-A-YP TP PILLOW PAIR",
      "Family": "0217",
      "Cube": 2.77,
      "Avg Daily Sales": 0.04,
      "Weekly Sales": 0.28,
      "Total Sales": 3.0,
      "QOH": 8.0,
      "Inbound": 0.0,
      "Available": 7.0,
      "Weeks of Stock": 25.0,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 9.6,
      "Order Point": 9.6,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 28.5714,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 3.0,
      "Order": 3.0,
      "L_Order": 3.0,
      "Store QOH": 0.0,
      "#/Box": 6.0,
      "# of Skus in Carton (PDM)": 6.0,
      "Avail Today": 8.0,
      "EOL AVAIL": 6.0,
      "Avail After Order": 10.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.1,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77412509",
      "Product ID (PDM)": 339799.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "BUTTERCUP",
      "Factory Color": "BUTTERCUP",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE OTTOMAN CUSHION BUTTERCUP",
      "Family": "1250",
      "Cube": 7.18,
      "Avg Daily Sales": 0.0267,
      "Weekly Sales": 0.1869,
      "Total Sales": 2.0,
      "QOH": 3.0,
      "Inbound": 0.0,
      "Available": 3.0,
      "Weeks of Stock": 16.0714,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 6.4,
      "Order Point": 6.4,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 16.0714,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 3.0,
      "Order": 3.0,
      "L_Order": 3.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 3.0,
      "EOL AVAIL": 3.0,
      "Avail After Order": 6.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "75510125",
      "Product ID (PDM)": 159006.0,
      "Alias": "HMRI 302",
      "FOB": "GUNTOWN",
      "Color": "LINEN",
      "Factory Color": "LINEN",
      "Theme": "PATMOS",
      "Description": "PATMOS SIDE CHR CUSH LINEN",
      "Family": "1012",
      "Cube": 1.07,
      "Avg Daily Sales": 0.36,
      "Weekly Sales": 2.52,
      "Total Sales": 27.0,
      "QOH": 102.0,
      "Inbound": 0.0,
      "Available": 82.0,
      "Weeks of Stock": 32.5397,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 86.4,
      "Order Point": 86.4,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 40.4762,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 4.0,
      "Order": 4.0,
      "L_Order": 4.0,
      "Store QOH": 34.0,
      "#/Box": 10.0,
      "# of Skus in Carton (PDM)": 10.0,
      "Avail Today": 102.0,
      "EOL AVAIL": 62.0,
      "Avail After Order": 86.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.04,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77412369",
      "Product ID (PDM)": 223937.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "INDIGO",
      "Factory Color": "INDIGO",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE OTTO CUSH INDIGO",
      "Family": "1236",
      "Cube": 3.17,
      "Avg Daily Sales": 0.0933,
      "Weekly Sales": 0.6531,
      "Total Sales": 7.0,
      "QOH": 21.0,
      "Inbound": 0.0,
      "Available": 18.0,
      "Weeks of Stock": 27.551,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 22.4,
      "Order Point": 22.4,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 32.1429,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 4.0,
      "Order": 4.0,
      "L_Order": 4.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 21.0,
      "EOL AVAIL": 15.0,
      "Avail After Order": 22.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.09,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "75912230",
      "Product ID (PDM)": 243025.0,
      "Alias": "HMRI 303",
      "FOB": "GUNTOWN",
      "Color": "STEEL",
      "Factory Color": "STEEL",
      "Theme": "SIESTA KEY",
      "Description": "SIESTA KEY 102\" BENCH PAD IO STEEL",
      "Family": "1223",
      "Cube": 6.73,
      "Avg Daily Sales": 0.04,
      "Weekly Sales": 0.28,
      "Total Sales": 3.0,
      "QOH": 3.0,
      "Inbound": 0.0,
      "Available": 3.0,
      "Weeks of Stock": 10.7143,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 9.6,
      "Order Point": 9.6,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 10.7143,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 7.0,
      "Order": 7.0,
      "L_Order": 7.0,
      "Store QOH": 0.0,
      "#/Box": 20.0,
      "# of Skus in Carton (PDM)": 20.0,
      "Avail Today": 3.0,
      "EOL AVAIL": 3.0,
      "Avail After Order": 10.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.2,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77210448",
      "Product ID (PDM)": 53650.0,
      "Alias": "HMRI 304",
      "FOB": "GUNTOWN",
      "Color": "INDIGO",
      "Factory Color": "INDIGO",
      "Theme": "PLEASANT BAY",
      "Description": "PLEASANT BAY LOVESEAT CUSHION SUNBRELLA INDIGO",
      "Family": "1044",
      "Cube": 15.78,
      "Avg Daily Sales": 0.0933,
      "Weekly Sales": 0.6531,
      "Total Sales": 7.0,
      "QOH": 9.0,
      "Inbound": 5.0,
      "Available": 14.0,
      "Weeks of Stock": 21.4286,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 22.4,
      "Order Point": 22.4,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 21.4286,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 8.0,
      "Order": 8.0,
      "L_Order": 8.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 14.0,
      "EOL AVAIL": 19.0,
      "Avail After Order": 22.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.64,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77312406",
      "Product ID (PDM)": 339794.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "TERRACOTTA",
      "Factory Color": "TERRACOTTA",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE CLUB CHAIR CUSHION TERRACOTTA",
      "Family": "1240",
      "Cube": 8.71,
      "Avg Daily Sales": 0.08,
      "Weekly Sales": 0.56,
      "Total Sales": 6.0,
      "QOH": 13.0,
      "Inbound": 0.0,
      "Available": 11.0,
      "Weeks of Stock": 19.6429,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 19.2,
      "Order Point": 19.2,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 19.6429,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 8.0,
      "Order": 8.0,
      "L_Order": 8.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 11.0,
      "EOL AVAIL": 9.0,
      "Avail After Order": 19.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "75612373",
      "Product ID (PDM)": 248260.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "CHARCOAL",
      "Factory Color": "CHARCOAL",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE DIN ARM CHR CUSH IO CHARCOAL",
      "Family": "1237",
      "Cube": 1.07,
      "Avg Daily Sales": 0.1333,
      "Weekly Sales": 0.9331,
      "Total Sales": 10.0,
      "QOH": 32.0,
      "Inbound": 0.0,
      "Available": 22.0,
      "Weeks of Stock": 23.5714,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 32.0,
      "Order Point": 32.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 34.2857,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 10.0,
      "Order": 10.0,
      "L_Order": 10.0,
      "Store QOH": 0.0,
      "#/Box": 10.0,
      "# of Skus in Carton (PDM)": 10.0,
      "Avail Today": 32.0,
      "EOL AVAIL": 12.0,
      "Avail After Order": 32.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.04,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "78812902",
      "Product ID (PDM)": 223354.0,
      "Alias": "HMRI ZAPOTEC",
      "FOB": "GUNTOWN",
      "Color": "BLACK",
      "Factory Color": "BLACK",
      "Theme": "ZAPOTEC",
      "Description": "P129-KP ZAPOTEC KIDNEY",
      "Family": "1290",
      "Cube": 0.52,
      "Avg Daily Sales": 0.1333,
      "Weekly Sales": 0.9331,
      "Total Sales": 10.0,
      "QOH": 21.0,
      "Inbound": 0.0,
      "Available": 21.0,
      "Weeks of Stock": 22.5,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 32.0,
      "Order Point": 32.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 22.5,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 11.0,
      "Order": 11.0,
      "L_Order": 11.0,
      "Store QOH": 67.0,
      "#/Box": 16.0,
      "# of Skus in Carton (PDM)": 16.0,
      "Avail Today": 21.0,
      "EOL AVAIL": 21.0,
      "Avail After Order": 32.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.02,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77710448",
      "Product ID (PDM)": 232394.0,
      "Alias": "HMRI 304",
      "FOB": "GUNTOWN",
      "Color": "INDIGO",
      "Factory Color": "INDIGO",
      "Theme": "PLEASANT BAY",
      "Description": "PB ARMLESS CHR CUSH INDIGO",
      "Family": "1044",
      "Cube": 9.01,
      "Avg Daily Sales": 0.12,
      "Weekly Sales": 0.84,
      "Total Sales": 9.0,
      "QOH": 9.0,
      "Inbound": 14.0,
      "Available": 17.0,
      "Weeks of Stock": 20.2381,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 28.8,
      "Order Point": 28.8,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 16.6667,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 12.0,
      "Order": 12.0,
      "L_Order": 12.0,
      "Store QOH": 7.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 14.0,
      "EOL AVAIL": 25.0,
      "Avail After Order": 29.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77412345",
      "Product ID (PDM)": 223921.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "SEAGULL",
      "Factory Color": "SEAGULL",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE OTTO CUSH SEAGULL",
      "Family": "1234",
      "Cube": 3.17,
      "Avg Daily Sales": 0.1067,
      "Weekly Sales": 0.7469,
      "Total Sales": 8.0,
      "QOH": 15.0,
      "Inbound": 0.0,
      "Available": 14.0,
      "Weeks of Stock": 18.75,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 25.6,
      "Order Point": 25.6,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 20.0893,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 12.0,
      "Order": 12.0,
      "L_Order": 12.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 15.0,
      "EOL AVAIL": 13.0,
      "Avail After Order": 26.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.09,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "18902191",
      "Product ID (PDM)": 337261.0,
      "Alias": "HMRI APOLLO WINE",
      "FOB": "GUNTOWN",
      "Color": "WINE",
      "Factory Color": "WINE",
      "Theme": "GRACIE",
      "Description": "0200-PP-A-YR TP PILLOW PAIR",
      "Family": "0219",
      "Cube": 2.77,
      "Avg Daily Sales": 0.1067,
      "Weekly Sales": 0.7469,
      "Total Sales": 8.0,
      "QOH": 8.0,
      "Inbound": 6.0,
      "Available": 12.0,
      "Weeks of Stock": 16.0714,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 25.6,
      "Order Point": 25.6,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 10.7143,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 14.0,
      "Order": 14.0,
      "L_Order": 14.0,
      "Store QOH": 0.0,
      "#/Box": 6.0,
      "# of Skus in Carton (PDM)": 6.0,
      "Avail Today": 8.0,
      "EOL AVAIL": 16.0,
      "Avail After Order": 26.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.1,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77110446",
      "Product ID (PDM)": 24156.0,
      "Alias": "HMRI 304",
      "FOB": "GUNTOWN",
      "Color": "INDIGO",
      "Factory Color": "INDIGO",
      "Theme": "PLEASANT BAY",
      "Description": "PLEASANT BAY  SOFA CUSHION SUNBRELLA INDIGO",
      "Family": "1044",
      "Cube": 22.96,
      "Avg Daily Sales": 0.2,
      "Weekly Sales": 1.4,
      "Total Sales": 15.0,
      "QOH": 35.0,
      "Inbound": 0.0,
      "Available": 34.0,
      "Weeks of Stock": 24.2857,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 48.0,
      "Order Point": 48.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 25.0,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 14.0,
      "Order": 14.0,
      "L_Order": 14.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 35.0,
      "EOL AVAIL": 33.0,
      "Avail After Order": 48.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.85,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "18903143",
      "Product ID (PDM)": 260984.0,
      "Alias": "HMRI CRAFTED ECLIPSE",
      "FOB": "GUNTOWN",
      "Color": "ECLIPSE",
      "Factory Color": "ECLIPSE",
      "Theme": "CRAFTED",
      "Description": "0200-PPBXL-RW TP PILLOW PAIR",
      "Family": "0314",
      "Cube": 3.01,
      "Avg Daily Sales": 0.1333,
      "Weekly Sales": 0.9331,
      "Total Sales": 10.0,
      "QOH": 19.0,
      "Inbound": 0.0,
      "Available": 17.0,
      "Weeks of Stock": 18.2143,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 32.0,
      "Order Point": 32.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 20.3571,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 15.0,
      "Order": 15.0,
      "L_Order": 15.0,
      "Store QOH": 0.0,
      "#/Box": 6.0,
      "# of Skus in Carton (PDM)": 6.0,
      "Avail Today": 19.0,
      "EOL AVAIL": 15.0,
      "Avail After Order": 32.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.18,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "75611701",
      "Product ID (PDM)": 334660.0,
      "Alias": "HMRI 312",
      "FOB": "GUNTOWN",
      "Color": "MIST",
      "Factory Color": "MIST",
      "Theme": "MONTECELLO",
      "Description": "MONTECELLO DINING SIDE CHAIR CUSHION MIST",
      "Family": "1170",
      "Cube": 10.74,
      "Avg Daily Sales": 0.2,
      "Weekly Sales": 1.4,
      "Total Sales": 15.0,
      "QOH": 37.0,
      "Inbound": 0.0,
      "Available": 33.0,
      "Weeks of Stock": 23.5714,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 48.0,
      "Order Point": 48.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 26.4286,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 15.0,
      "Order": 15.0,
      "L_Order": 15.0,
      "Store QOH": 0.0,
      "#/Box": 10.0,
      "# of Skus in Carton (PDM)": 10.0,
      "Avail Today": 37.0,
      "EOL AVAIL": 29.0,
      "Avail After Order": 48.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "78300464",
      "Product ID (PDM)": 347611.0,
      "Alias": "HMRI P332",
      "FOB": "GUNTOWN",
      "Color": "MINERAL",
      "Factory Color": "MINERAL",
      "Theme": "LANAI",
      "Description": "LANAI CORNER CUSHION LINDY MINERAL",
      "Family": "0046",
      "Cube": 12.64,
      "Avg Daily Sales": 0.2133,
      "Weekly Sales": 1.4931,
      "Total Sales": 16.0,
      "QOH": 22.0,
      "Inbound": 16.0,
      "Available": 35.0,
      "Weeks of Stock": 23.4375,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 51.2,
      "Order Point": 51.2,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 14.7321,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 16.0,
      "Order": 16.0,
      "L_Order": 16.0,
      "Store QOH": 11.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 22.0,
      "EOL AVAIL": 48.0,
      "Avail After Order": 51.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77410000",
      "Product ID (PDM)": 224095.0,
      "Alias": "HMRI 302",
      "FOB": "GUNTOWN",
      "Color": "LINEN",
      "Factory Color": "LINEN",
      "Theme": "PATMOS",
      "Description": "PATMOS OTTO SHORT LINEN",
      "Family": "1000",
      "Cube": 3.0,
      "Avg Daily Sales": 0.1467,
      "Weekly Sales": 1.0269,
      "Total Sales": 11.0,
      "QOH": 9.0,
      "Inbound": 12.0,
      "Available": 19.0,
      "Weeks of Stock": 18.5065,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 35.2,
      "Order Point": 35.2,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 8.7662,
      "Qty To WHS": 0.0,
      "Qty From WHS": 1.0,
      "Calc. Order": 16.0,
      "Order": 16.0,
      "L_Order": 16.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 9.0,
      "EOL AVAIL": 29.0,
      "Avail After Order": 35.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.09,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77210640",
      "Product ID (PDM)": 58112.0,
      "Alias": "HMRI 304",
      "FOB": "GUNTOWN",
      "Color": "VAPOR",
      "Factory Color": "VAPOR",
      "Theme": "PLEASANT BAY",
      "Description": "PLEASANT BAY  LOVESEAT CUSHION SUNBRELLA VAPOR",
      "Family": "1064",
      "Cube": 15.78,
      "Avg Daily Sales": 0.1333,
      "Weekly Sales": 0.9331,
      "Total Sales": 10.0,
      "QOH": 8.0,
      "Inbound": 6.0,
      "Available": 14.0,
      "Weeks of Stock": 15.0,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 32.0,
      "Order Point": 32.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 15.0,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 18.0,
      "Order": 18.0,
      "L_Order": 18.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 14.0,
      "EOL AVAIL": 20.0,
      "Avail After Order": 32.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.64,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77512361",
      "Product ID (PDM)": 223938.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "INDIGO",
      "Factory Color": "INDIGO",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE CHAISE CUSH INDIGO",
      "Family": "1236",
      "Cube": 9.19,
      "Avg Daily Sales": 0.1733,
      "Weekly Sales": 1.2131,
      "Total Sales": 13.0,
      "QOH": 32.0,
      "Inbound": 0.0,
      "Available": 24.0,
      "Weeks of Stock": 19.7802,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 41.6,
      "Order Point": 41.6,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 26.3736,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 18.0,
      "Order": 18.0,
      "L_Order": 18.0,
      "Store QOH": 14.0,
      "#/Box": 5.0,
      "# of Skus in Carton (PDM)": 5.0,
      "Avail Today": 32.0,
      "EOL AVAIL": 16.0,
      "Avail After Order": 42.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.34,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "93302075",
      "Product ID (PDM)": 300351.0,
      "Alias": "HMRI POUF TEAL",
      "FOB": "GUNTOWN",
      "Color": "TEAL",
      "Factory Color": "TEAL",
      "Theme": "PALL",
      "Description": "P207-AO TEAL POUF OTTOMAN",
      "Family": "0207",
      "Cube": 4.85,
      "Avg Daily Sales": 0.1733,
      "Weekly Sales": 1.2131,
      "Total Sales": 13.0,
      "QOH": 20.0,
      "Inbound": 0.0,
      "Available": 18.0,
      "Weeks of Stock": 14.8352,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 41.6,
      "Order Point": 41.6,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 16.4835,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 24.0,
      "Order": 24.0,
      "L_Order": 24.0,
      "Store QOH": 52.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 20.0,
      "EOL AVAIL": 16.0,
      "Avail After Order": 42.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77810642",
      "Product ID (PDM)": 232398.0,
      "Alias": "HMRI 304",
      "FOB": "GUNTOWN",
      "Color": "VAPOR",
      "Factory Color": "VAPOR",
      "Theme": "PLEASANT BAY",
      "Description": "PB WEDGE CUSH VAPOR",
      "Family": "1064",
      "Cube": 16.62,
      "Avg Daily Sales": 0.16,
      "Weekly Sales": 1.12,
      "Total Sales": 12.0,
      "QOH": 10.0,
      "Inbound": 11.0,
      "Available": 14.0,
      "Weeks of Stock": 12.5,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 38.4,
      "Order Point": 38.4,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 16.9643,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 24.0,
      "Order": 24.0,
      "L_Order": 24.0,
      "Store QOH": 6.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 19.0,
      "EOL AVAIL": 18.0,
      "Avail After Order": 38.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "78811215",
      "Product ID (PDM)": 140378.0,
      "Alias": "HMRI LAVISH PALM MARINE",
      "FOB": "GUNTOWN",
      "Color": "MARINE",
      "Factory Color": "MARINE",
      "Theme": "LAVISH PALM MARINE",
      "Description": "P112-KP LAV PALM MAR KID PILLOW",
      "Family": "1121",
      "Cube": 0.52,
      "Avg Daily Sales": 0.3733,
      "Weekly Sales": 2.6131,
      "Total Sales": 28.0,
      "QOH": 36.0,
      "Inbound": 32.0,
      "Available": 66.0,
      "Weeks of Stock": 25.2551,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 89.6,
      "Order Point": 89.6,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 13.7755,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 24.0,
      "Order": 24.0,
      "L_Order": 24.0,
      "Store QOH": 64.0,
      "#/Box": 16.0,
      "# of Skus in Carton (PDM)": 16.0,
      "Avail Today": 36.0,
      "EOL AVAIL": 96.0,
      "Avail After Order": 90.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.02,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "18902204",
      "Product ID (PDM)": 337262.0,
      "Alias": "HMRI APOLLO MULTI",
      "FOB": "GUNTOWN",
      "Color": "MULTI",
      "Factory Color": "MULTI",
      "Theme": "GRACIE",
      "Description": "0601-PP-A PILLOW PACK",
      "Family": "0220",
      "Cube": 8.3,
      "Avg Daily Sales": 0.16,
      "Weekly Sales": 1.12,
      "Total Sales": 12.0,
      "QOH": 5.0,
      "Inbound": 8.0,
      "Available": 13.0,
      "Weeks of Stock": 11.6071,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 38.4,
      "Order Point": 38.4,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 8.0357,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 25.0,
      "Order": 25.0,
      "L_Order": 25.0,
      "Store QOH": 35.0,
      "#/Box": 2.0,
      "# of Skus in Carton (PDM)": 2.0,
      "Avail Today": 9.0,
      "EOL AVAIL": 21.0,
      "Avail After Order": 38.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.29,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77510127",
      "Product ID (PDM)": 145210.0,
      "Alias": "HMRI 302",
      "FOB": "GUNTOWN",
      "Color": "LINEN",
      "Factory Color": "LINEN",
      "Theme": "PATMOS",
      "Description": "PATMOS CHAISE CUSH LINEN",
      "Family": "1012",
      "Cube": 6.3,
      "Avg Daily Sales": 0.2133,
      "Weekly Sales": 1.4931,
      "Total Sales": 16.0,
      "QOH": 33.0,
      "Inbound": 0.0,
      "Available": 25.0,
      "Weeks of Stock": 16.7411,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 51.2,
      "Order Point": 51.2,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 22.0982,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 26.0,
      "Order": 26.0,
      "L_Order": 26.0,
      "Store QOH": 12.0,
      "#/Box": 6.0,
      "# of Skus in Carton (PDM)": 6.0,
      "Avail Today": 33.0,
      "EOL AVAIL": 17.0,
      "Avail After Order": 51.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.25,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "78300363",
      "Product ID (PDM)": 347610.0,
      "Alias": "HMRI P332",
      "FOB": "GUNTOWN",
      "Color": "CREAM",
      "Factory Color": "CREAM",
      "Theme": "LANAI",
      "Description": "LANAI CORNER CUSHION LINDY CREAM",
      "Family": "0036",
      "Cube": 12.64,
      "Avg Daily Sales": 0.2933,
      "Weekly Sales": 2.0531,
      "Total Sales": 22.0,
      "QOH": 38.0,
      "Inbound": 8.0,
      "Available": 41.0,
      "Weeks of Stock": 19.9675,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 70.4,
      "Order Point": 70.4,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 22.4026,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 29.0,
      "Order": 29.0,
      "L_Order": 29.0,
      "Store QOH": 10.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 46.0,
      "EOL AVAIL": 44.0,
      "Avail After Order": 70.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77410442",
      "Product ID (PDM)": 124935.0,
      "Alias": "HMRI 304",
      "FOB": "GUNTOWN",
      "Color": "INDIGO",
      "Factory Color": "INDIGO",
      "Theme": "PLEASANT BAY",
      "Description": "PLEASANT BAY OTTOMAN CUSHION SUNBRELLA INDIGO",
      "Family": "1044",
      "Cube": 2.87,
      "Avg Daily Sales": 0.1733,
      "Weekly Sales": 1.2131,
      "Total Sales": 13.0,
      "QOH": 18.0,
      "Inbound": 0.0,
      "Available": 13.0,
      "Weeks of Stock": 10.7143,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 41.6,
      "Order Point": 41.6,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 14.8352,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 29.0,
      "Order": 29.0,
      "L_Order": 29.0,
      "Store QOH": 2.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 18.0,
      "EOL AVAIL": 8.0,
      "Avail After Order": 42.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.08,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77112363",
      "Product ID (PDM)": 223936.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "INDIGO",
      "Factory Color": "INDIGO",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE SUNBRELLA INDIGO SOFA CUSHION",
      "Family": "1236",
      "Cube": 22.96,
      "Avg Daily Sales": 0.2133,
      "Weekly Sales": 1.4931,
      "Total Sales": 16.0,
      "QOH": 29.0,
      "Inbound": 0.0,
      "Available": 22.0,
      "Weeks of Stock": 14.7321,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 51.2,
      "Order Point": 51.2,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 18.75,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 29.0,
      "Order": 29.0,
      "L_Order": 29.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 28.0,
      "EOL AVAIL": 15.0,
      "Avail After Order": 51.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.85,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77810440",
      "Product ID (PDM)": 232395.0,
      "Alias": "HMRI 304",
      "FOB": "GUNTOWN",
      "Color": "INDIGO",
      "Factory Color": "INDIGO",
      "Theme": "PLEASANT BAY",
      "Description": "PB WEDGE CUSH INDIGO",
      "Family": "1044",
      "Cube": 16.62,
      "Avg Daily Sales": 0.1467,
      "Weekly Sales": 1.0269,
      "Total Sales": 11.0,
      "QOH": 8.0,
      "Inbound": 5.0,
      "Available": 5.0,
      "Weeks of Stock": 4.8701,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 35.2,
      "Order Point": 35.2,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 11.6883,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 30.0,
      "Order": 30.0,
      "L_Order": 30.0,
      "Store QOH": 7.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 12.0,
      "EOL AVAIL": 2.0,
      "Avail After Order": 35.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77112818",
      "Product ID (PDM)": 205186.0,
      "Alias": "HMRI 315",
      "FOB": "GUNTOWN",
      "Color": "PARCHMENT",
      "Factory Color": "PARCHMENT",
      "Theme": "LAKE BREEZE",
      "Description": "LB/LKBRZ SOFA CUSH PARCHMENT",
      "Family": "1281",
      "Cube": 22.96,
      "Avg Daily Sales": 0.24,
      "Weekly Sales": 1.68,
      "Total Sales": 18.0,
      "QOH": 20.0,
      "Inbound": 12.0,
      "Available": 26.0,
      "Weeks of Stock": 15.4762,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 57.6,
      "Order Point": 57.6,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 11.9048,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 32.0,
      "Order": 32.0,
      "L_Order": 32.0,
      "Store QOH": 0.0,
      "#/Box": 2.0,
      "# of Skus in Carton (PDM)": 2.0,
      "Avail Today": 20.0,
      "EOL AVAIL": 32.0,
      "Avail After Order": 58.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.85,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77412814",
      "Product ID (PDM)": 213689.0,
      "Alias": "HMRI 315",
      "FOB": "GUNTOWN",
      "Color": "PARCHMENT",
      "Factory Color": "PARCHMENT",
      "Theme": "LAKE BREEZE",
      "Description": "LB/LKBRZ OTTO CUSH PARCHMENT",
      "Family": "1281",
      "Cube": 3.16,
      "Avg Daily Sales": 0.1733,
      "Weekly Sales": 1.2131,
      "Total Sales": 13.0,
      "QOH": 5.0,
      "Inbound": 10.0,
      "Available": 10.0,
      "Weeks of Stock": 8.2418,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 41.6,
      "Order Point": 41.6,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 4.1209,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 32.0,
      "Order": 32.0,
      "L_Order": 32.0,
      "Store QOH": 0.0,
      "#/Box": 2.0,
      "# of Skus in Carton (PDM)": 2.0,
      "Avail Today": 5.0,
      "EOL AVAIL": 15.0,
      "Avail After Order": 42.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.21,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "75610646",
      "Product ID (PDM)": 187310.0,
      "Alias": "HMRI 304",
      "FOB": "GUNTOWN",
      "Color": "VAPOR",
      "Factory Color": "VAPOR",
      "Theme": "PLEASANT BAY",
      "Description": "PLEASANT BAY DINING CHAIR CUSHION VAPOR",
      "Family": "1064",
      "Cube": 1.07,
      "Avg Daily Sales": 0.32,
      "Weekly Sales": 2.24,
      "Total Sales": 24.0,
      "QOH": 58.0,
      "Inbound": 0.0,
      "Available": 44.0,
      "Weeks of Stock": 19.6429,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 76.8,
      "Order Point": 76.8,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 25.8929,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 33.0,
      "Order": 33.0,
      "L_Order": 33.0,
      "Store QOH": 7.0,
      "#/Box": 10.0,
      "# of Skus in Carton (PDM)": 10.0,
      "Avail Today": 58.0,
      "EOL AVAIL": 30.0,
      "Avail After Order": 77.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.04,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "75612347",
      "Product ID (PDM)": 223923.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "SEAGULL",
      "Factory Color": "SEAGULL",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE DN ARM CHR CUSH SEAGULL",
      "Family": "1234",
      "Cube": 1.1,
      "Avg Daily Sales": 0.2667,
      "Weekly Sales": 1.8669,
      "Total Sales": 20.0,
      "QOH": 35.0,
      "Inbound": 0.0,
      "Available": 31.0,
      "Weeks of Stock": 16.6071,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 64.0,
      "Order Point": 64.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 18.75,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 33.0,
      "Order": 33.0,
      "L_Order": 33.0,
      "Store QOH": 34.0,
      "#/Box": 10.0,
      "# of Skus in Carton (PDM)": 10.0,
      "Avail Today": 35.0,
      "EOL AVAIL": 27.0,
      "Avail After Order": 64.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.04,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77212810",
      "Product ID (PDM)": 216164.0,
      "Alias": "HMRI 315",
      "FOB": "GUNTOWN",
      "Color": "PARCHMENT",
      "Factory Color": "PARCHMENT",
      "Theme": "LAKE BREEZE",
      "Description": "LAKE BREEZE LOVESEAT LAF/RAF CUSH PARCHMENT",
      "Family": "1281",
      "Cube": 15.79,
      "Avg Daily Sales": 0.1867,
      "Weekly Sales": 1.3069,
      "Total Sales": 14.0,
      "QOH": 12.0,
      "Inbound": 6.0,
      "Available": 12.0,
      "Weeks of Stock": 9.1837,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 44.8,
      "Order Point": 44.8,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 7.6531,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 33.0,
      "Order": 33.0,
      "L_Order": 33.0,
      "Store QOH": 0.0,
      "#/Box": 2.0,
      "# of Skus in Carton (PDM)": 2.0,
      "Avail Today": 10.0,
      "EOL AVAIL": 12.0,
      "Avail After Order": 45.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.64,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "93302099",
      "Product ID (PDM)": 300353.0,
      "Alias": "HMRI POUF OXIDE",
      "FOB": "GUNTOWN",
      "Color": "OXIDE",
      "Factory Color": "OXIDE",
      "Theme": "PALL",
      "Description": "P209-AO OXIDE POUF OTTOMAN",
      "Family": "0209",
      "Cube": 4.85,
      "Avg Daily Sales": 0.2533,
      "Weekly Sales": 1.7731,
      "Total Sales": 19.0,
      "QOH": 33.0,
      "Inbound": 0.0,
      "Available": 27.0,
      "Weeks of Stock": 15.2256,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 60.8,
      "Order Point": 60.8,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 18.609,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 34.0,
      "Order": 34.0,
      "L_Order": 34.0,
      "Store QOH": 51.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 33.0,
      "EOL AVAIL": 21.0,
      "Avail After Order": 61.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77212000",
      "Product ID (PDM)": 238792.0,
      "Alias": "HMRI 302",
      "FOB": "GUNTOWN",
      "Color": "STEEL",
      "Factory Color": "STEEL",
      "Theme": "PATMOS",
      "Description": "PATMOS L/S CUSH STEEL",
      "Family": "1200",
      "Cube": 15.7,
      "Avg Daily Sales": 0.2,
      "Weekly Sales": 1.4,
      "Total Sales": 15.0,
      "QOH": 22.0,
      "Inbound": 0.0,
      "Available": 14.0,
      "Weeks of Stock": 10.0,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 48.0,
      "Order Point": 48.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 13.5714,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 34.0,
      "Order": 34.0,
      "L_Order": 34.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 19.0,
      "EOL AVAIL": 6.0,
      "Avail After Order": 48.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.64,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "18902189",
      "Product ID (PDM)": 337260.0,
      "Alias": "HMRI APOLLO TEAL",
      "FOB": "GUNTOWN",
      "Color": "TEAL",
      "Factory Color": "TEAL",
      "Theme": "GRACIE",
      "Description": "0200-PP-A-YQ TP PILLOW PAIR",
      "Family": "0218",
      "Cube": 2.77,
      "Avg Daily Sales": 0.2133,
      "Weekly Sales": 1.4931,
      "Total Sales": 16.0,
      "QOH": 17.0,
      "Inbound": 0.0,
      "Available": 15.0,
      "Weeks of Stock": 10.0446,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 51.2,
      "Order Point": 51.2,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 11.3839,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 36.0,
      "Order": 36.0,
      "L_Order": 36.0,
      "Store QOH": 0.0,
      "#/Box": 6.0,
      "# of Skus in Carton (PDM)": 6.0,
      "Avail Today": 17.0,
      "EOL AVAIL": 13.0,
      "Avail After Order": 51.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.1,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "75512371",
      "Product ID (PDM)": 248257.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "CHARCOAL",
      "Factory Color": "CHARCOAL",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE DIN SIDE CHR CUSH IO CHARCOAL",
      "Family": "1237",
      "Cube": 1.07,
      "Avg Daily Sales": 0.3067,
      "Weekly Sales": 2.1469,
      "Total Sales": 23.0,
      "QOH": 52.0,
      "Inbound": 0.0,
      "Available": 38.0,
      "Weeks of Stock": 17.7019,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 73.6,
      "Order Point": 73.6,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 24.2236,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 36.0,
      "Order": 36.0,
      "L_Order": 36.0,
      "Store QOH": 0.0,
      "#/Box": 10.0,
      "# of Skus in Carton (PDM)": 10.0,
      "Avail Today": 52.0,
      "EOL AVAIL": 24.0,
      "Avail After Order": 74.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.04,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77310123",
      "Product ID (PDM)": 88227.0,
      "Alias": "HMRI 302",
      "FOB": "GUNTOWN",
      "Color": "LINEN",
      "Factory Color": "LINEN",
      "Theme": "PATMOS",
      "Description": "PATMOS CLUB/SWVL CUSH LIINEN",
      "Family": "1012",
      "Cube": 9.0,
      "Avg Daily Sales": 0.44,
      "Weekly Sales": 3.08,
      "Total Sales": 33.0,
      "QOH": 75.0,
      "Inbound": 0.0,
      "Available": 68.0,
      "Weeks of Stock": 22.0779,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 105.6,
      "Order Point": 105.6,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 24.026,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 38.0,
      "Order": 38.0,
      "L_Order": 38.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 74.0,
      "EOL AVAIL": 61.0,
      "Avail After Order": 106.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.28,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "18902165",
      "Product ID (PDM)": 337258.0,
      "Alias": "HMRI APOLLO PALM",
      "FOB": "GUNTOWN",
      "Color": "PALM",
      "Factory Color": "PALM",
      "Theme": "GRACIE",
      "Description": "0200-PP-A-YO TP PILLOW PAIR",
      "Family": "0216",
      "Cube": 2.77,
      "Avg Daily Sales": 0.2133,
      "Weekly Sales": 1.4931,
      "Total Sales": 16.0,
      "QOH": 13.0,
      "Inbound": 0.0,
      "Available": 11.0,
      "Weeks of Stock": 7.3661,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 51.2,
      "Order Point": 51.2,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 8.7054,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 40.0,
      "Order": 40.0,
      "L_Order": 40.0,
      "Store QOH": 0.0,
      "#/Box": 6.0,
      "# of Skus in Carton (PDM)": 6.0,
      "Avail Today": 13.0,
      "EOL AVAIL": 9.0,
      "Avail After Order": 51.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.1,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77112349",
      "Product ID (PDM)": 223917.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "SEAGULL",
      "Factory Color": "SEAGULL",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE SUNBRELLA SEAGULL SOFA CUSHION",
      "Family": "1234",
      "Cube": 22.96,
      "Avg Daily Sales": 0.28,
      "Weekly Sales": 1.96,
      "Total Sales": 21.0,
      "QOH": 36.0,
      "Inbound": 0.0,
      "Available": 27.0,
      "Weeks of Stock": 13.7755,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 67.2,
      "Order Point": 67.2,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 18.3673,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 40.0,
      "Order": 40.0,
      "L_Order": 40.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 36.0,
      "EOL AVAIL": 18.0,
      "Avail After Order": 67.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.85,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77512816",
      "Product ID (PDM)": 314416.0,
      "Alias": "HMRI 315",
      "FOB": "GUNTOWN",
      "Color": "PARCHMENT",
      "Factory Color": "PARCHMENT",
      "Theme": "LAKE BREEZE",
      "Description": "LAKE BREEZE SUNBRELLA PARCHMENT CHAISE CUSHION",
      "Family": "1281",
      "Cube": 6.3,
      "Avg Daily Sales": 0.28,
      "Weekly Sales": 1.96,
      "Total Sales": 21.0,
      "QOH": 18.0,
      "Inbound": 16.0,
      "Available": 26.0,
      "Weeks of Stock": 13.2653,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 67.2,
      "Order Point": 67.2,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 9.1837,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 41.0,
      "Order": 41.0,
      "L_Order": 41.0,
      "Store QOH": 7.0,
      "#/Box": 4.0,
      "# of Skus in Carton (PDM)": 4.0,
      "Avail Today": 18.0,
      "EOL AVAIL": 34.0,
      "Avail After Order": 67.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77512373",
      "Product ID (PDM)": 248289.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "CHARCOAL",
      "Factory Color": "CHARCOAL",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE CHAISE CUSH IO CHARCOAL",
      "Family": "1237",
      "Cube": 9.19,
      "Avg Daily Sales": 0.24,
      "Weekly Sales": 1.68,
      "Total Sales": 18.0,
      "QOH": 17.0,
      "Inbound": 0.0,
      "Available": 14.0,
      "Weeks of Stock": 8.3333,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 57.6,
      "Order Point": 57.6,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 10.119,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 44.0,
      "Order": 44.0,
      "L_Order": 44.0,
      "Store QOH": 0.0,
      "#/Box": 5.0,
      "# of Skus in Carton (PDM)": 5.0,
      "Avail Today": 17.0,
      "EOL AVAIL": 11.0,
      "Avail After Order": 58.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.34,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "93302114",
      "Product ID (PDM)": 324248.0,
      "Alias": "HMRI BOUCLE ALMOND POUF",
      "FOB": "GUNTOWN",
      "Color": "ALMOND",
      "Factory Color": "ALMOND",
      "Theme": "PALL",
      "Description": "P211-AO SUN BOUCLE ALMOND POUF",
      "Family": "0211",
      "Cube": 4.85,
      "Avg Daily Sales": 0.32,
      "Weekly Sales": 2.24,
      "Total Sales": 24.0,
      "QOH": 17.0,
      "Inbound": 20.0,
      "Available": 31.0,
      "Weeks of Stock": 13.8393,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 76.8,
      "Order Point": 76.8,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 6.6964,
      "Qty To WHS": 0.0,
      "Qty From WHS": 6.0,
      "Calc. Order": 46.0,
      "Order": 46.0,
      "L_Order": 46.0,
      "Store QOH": 44.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 15.0,
      "EOL AVAIL": 45.0,
      "Avail After Order": 77.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77412004",
      "Product ID (PDM)": 238796.0,
      "Alias": "HMRI 302",
      "FOB": "GUNTOWN",
      "Color": "STEEL",
      "Factory Color": "STEEL",
      "Theme": "PATMOS",
      "Description": "PATMOS SHORT OTTO CUSH STEEL",
      "Family": "1200",
      "Cube": 3.0,
      "Avg Daily Sales": 0.3067,
      "Weekly Sales": 2.1469,
      "Total Sales": 23.0,
      "QOH": 32.0,
      "Inbound": 8.0,
      "Available": 26.0,
      "Weeks of Stock": 12.1118,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 73.6,
      "Order Point": 73.6,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 14.9068,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 48.0,
      "Order": 48.0,
      "L_Order": 48.0,
      "Store QOH": 15.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 32.0,
      "EOL AVAIL": 20.0,
      "Avail After Order": 74.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.09,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77610446",
      "Product ID (PDM)": 232393.0,
      "Alias": "HMRI 304",
      "FOB": "GUNTOWN",
      "Color": "INDIGO",
      "Factory Color": "INDIGO",
      "Theme": "PLEASANT BAY",
      "Description": "PLEASANT BAY LAF/RAF LOVESEAT CUSHION SUNBRELLA IN",
      "Family": "1044",
      "Cube": 22.97,
      "Avg Daily Sales": 0.2667,
      "Weekly Sales": 1.8669,
      "Total Sales": 20.0,
      "QOH": 20.0,
      "Inbound": 10.0,
      "Available": 14.0,
      "Weeks of Stock": 7.5,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 64.0,
      "Order Point": 64.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 15.0,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 50.0,
      "Order": 50.0,
      "L_Order": 50.0,
      "Store QOH": 14.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 28.0,
      "EOL AVAIL": 8.0,
      "Avail After Order": 64.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77510646",
      "Product ID (PDM)": 148910.0,
      "Alias": "HMRI 304",
      "FOB": "GUNTOWN",
      "Color": "VAPOR",
      "Factory Color": "VAPOR",
      "Theme": "PLEASANT BAY",
      "Description": "PLEASANT BAY CHAISE CUSHION SUNBRELLA VAPOR",
      "Family": "1064",
      "Cube": 6.3,
      "Avg Daily Sales": 0.4133,
      "Weekly Sales": 2.8931,
      "Total Sales": 31.0,
      "QOH": 11.0,
      "Inbound": 48.0,
      "Available": 45.0,
      "Weeks of Stock": 15.553,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 99.2,
      "Order Point": 99.2,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 19.7005,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 54.0,
      "Order": 54.0,
      "L_Order": 54.0,
      "Store QOH": 0.0,
      "#/Box": 6.0,
      "# of Skus in Carton (PDM)": 6.0,
      "Avail Today": 57.0,
      "EOL AVAIL": 79.0,
      "Avail After Order": 99.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.25,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77610648",
      "Product ID (PDM)": 232396.0,
      "Alias": "HMRI 304",
      "FOB": "GUNTOWN",
      "Color": "VAPOR",
      "Factory Color": "VAPOR",
      "Theme": "PLEASANT BAY",
      "Description": "PLEASANT BAY LAF/RAF LOVESEAT CUSHION SUNBRELLA VA",
      "Family": "1064",
      "Cube": 22.97,
      "Avg Daily Sales": 0.3467,
      "Weekly Sales": 2.4269,
      "Total Sales": 26.0,
      "QOH": 19.0,
      "Inbound": 23.0,
      "Available": 26.0,
      "Weeks of Stock": 10.7143,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 83.2,
      "Order Point": 83.2,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 15.2473,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 57.0,
      "Order": 57.0,
      "L_Order": 57.0,
      "Store QOH": 12.0,
      "#/Box": 2.0,
      "# of Skus in Carton (PDM)": 2.0,
      "Avail Today": 37.0,
      "EOL AVAIL": 34.0,
      "Avail After Order": 83.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "18902153",
      "Product ID (PDM)": 337257.0,
      "Alias": "HMRI APOLLO PAPRIKA",
      "FOB": "GUNTOWN",
      "Color": "PAPRIKA",
      "Factory Color": "PAPRIKA",
      "Theme": "GRACIE",
      "Description": "0200-PP-A-YN TP PILLOW PAIR",
      "Family": "0215",
      "Cube": 2.77,
      "Avg Daily Sales": 0.3333,
      "Weekly Sales": 2.3331,
      "Total Sales": 25.0,
      "QOH": 18.0,
      "Inbound": 6.0,
      "Available": 22.0,
      "Weeks of Stock": 9.4286,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 80.0,
      "Order Point": 80.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 7.7143,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 58.0,
      "Order": 58.0,
      "L_Order": 58.0,
      "Store QOH": 0.0,
      "#/Box": 6.0,
      "# of Skus in Carton (PDM)": 6.0,
      "Avail Today": 18.0,
      "EOL AVAIL": 26.0,
      "Avail After Order": 80.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.1,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77812367",
      "Product ID (PDM)": 223933.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "INDIGO",
      "Factory Color": "INDIGO",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE CLUB CHR CUSH INDIGO",
      "Family": "1236",
      "Cube": 9.02,
      "Avg Daily Sales": 0.4267,
      "Weekly Sales": 2.9869,
      "Total Sales": 32.0,
      "QOH": 53.0,
      "Inbound": 0.0,
      "Available": 42.0,
      "Weeks of Stock": 14.0625,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 102.4,
      "Order Point": 102.4,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 17.7455,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 60.0,
      "Order": 60.0,
      "L_Order": 60.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 53.0,
      "EOL AVAIL": 31.0,
      "Avail After Order": 102.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.28,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "93302087",
      "Product ID (PDM)": 300352.0,
      "Alias": "HMRI POUF TAUPE",
      "FOB": "GUNTOWN",
      "Color": "TAUPE",
      "Factory Color": "TAUPE",
      "Theme": "PALL",
      "Description": "P208-AO PEWTER POUF OTTOMAN",
      "Family": "0208",
      "Cube": 4.85,
      "Avg Daily Sales": 0.44,
      "Weekly Sales": 3.08,
      "Total Sales": 33.0,
      "QOH": 21.0,
      "Inbound": 30.0,
      "Available": 45.0,
      "Weeks of Stock": 14.6104,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 105.6,
      "Order Point": 105.6,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 5.5195,
      "Qty To WHS": 0.0,
      "Qty From WHS": 2.0,
      "Calc. Order": 61.0,
      "Order": 61.0,
      "L_Order": 61.0,
      "Store QOH": 53.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 17.0,
      "EOL AVAIL": 69.0,
      "Avail After Order": 106.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "93302063",
      "Product ID (PDM)": 300350.0,
      "Alias": "HMRI POUF INK",
      "FOB": "GUNTOWN",
      "Color": "INK",
      "Factory Color": "INK",
      "Theme": "PALL",
      "Description": "P206-AO INK POUF OTTOMAN",
      "Family": "0206",
      "Cube": 4.85,
      "Avg Daily Sales": 0.4267,
      "Weekly Sales": 2.9869,
      "Total Sales": 32.0,
      "QOH": 39.0,
      "Inbound": 4.0,
      "Available": 39.0,
      "Weeks of Stock": 13.058,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 102.4,
      "Order Point": 102.4,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 13.058,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 63.0,
      "Order": 63.0,
      "L_Order": 63.0,
      "Store QOH": 55.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 39.0,
      "EOL AVAIL": 39.0,
      "Avail After Order": 102.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77410644",
      "Product ID (PDM)": 126858.0,
      "Alias": "HMRI 304",
      "FOB": "GUNTOWN",
      "Color": "VAPOR",
      "Factory Color": "VAPOR",
      "Theme": "PLEASANT BAY",
      "Description": "PLEASANT BAY OTTOMAN CUSHION SUNBRELLA VAPOR",
      "Family": "1064",
      "Cube": 2.87,
      "Avg Daily Sales": 0.36,
      "Weekly Sales": 2.52,
      "Total Sales": 27.0,
      "QOH": 20.0,
      "Inbound": 12.0,
      "Available": 22.0,
      "Weeks of Stock": 8.7302,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 86.4,
      "Order Point": 86.4,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 12.6984,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 64.0,
      "Order": 64.0,
      "L_Order": 64.0,
      "Store QOH": 8.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 32.0,
      "EOL AVAIL": 24.0,
      "Avail After Order": 86.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.08,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "78811316",
      "Product ID (PDM)": 151016.0,
      "Alias": "HMRI LAVISH PALM GREEN",
      "FOB": "GUNTOWN",
      "Color": "GREEN",
      "Factory Color": "GREEN",
      "Theme": "LAVISH PALM GREEN",
      "Description": "P113-KP LAV PALM GREEN KID PILLOW",
      "Family": "1131",
      "Cube": 0.52,
      "Avg Daily Sales": 0.3333,
      "Weekly Sales": 2.3331,
      "Total Sales": 25.0,
      "QOH": 23.0,
      "Inbound": 0.0,
      "Available": 16.0,
      "Weeks of Stock": 6.8571,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 80.0,
      "Order Point": 80.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 8.5714,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 64.0,
      "Order": 64.0,
      "L_Order": 64.0,
      "Store QOH": 70.0,
      "#/Box": 16.0,
      "# of Skus in Carton (PDM)": 16.0,
      "Avail Today": 20.0,
      "EOL AVAIL": 9.0,
      "Avail After Order": 80.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.02,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77512006",
      "Product ID (PDM)": 238798.0,
      "Alias": "HMRI 302",
      "FOB": "GUNTOWN",
      "Color": "STEEL",
      "Factory Color": "STEEL",
      "Theme": "PATMOS",
      "Description": "PATMOS CHAISE CUSH STEEL",
      "Family": "1200",
      "Cube": 6.0,
      "Avg Daily Sales": 0.3733,
      "Weekly Sales": 2.6131,
      "Total Sales": 28.0,
      "QOH": 42.0,
      "Inbound": 0.0,
      "Available": 24.0,
      "Weeks of Stock": 9.1837,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 89.6,
      "Order Point": 89.6,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 14.5408,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 66.0,
      "Order": 66.0,
      "L_Order": 66.0,
      "Store QOH": 0.0,
      "#/Box": 6.0,
      "# of Skus in Carton (PDM)": 6.0,
      "Avail Today": 38.0,
      "EOL AVAIL": 6.0,
      "Avail After Order": 90.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.25,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "75612006",
      "Product ID (PDM)": 238788.0,
      "Alias": "HMRI 302",
      "FOB": "GUNTOWN",
      "Color": "STEEL",
      "Factory Color": "STEEL",
      "Theme": "PATMOS",
      "Description": "PATMOS DN A/C CUSH STEEL",
      "Family": "1200",
      "Cube": 1.0,
      "Avg Daily Sales": 0.4533,
      "Weekly Sales": 3.1731,
      "Total Sales": 34.0,
      "QOH": 51.0,
      "Inbound": 0.0,
      "Available": 41.0,
      "Weeks of Stock": 12.9202,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 108.8,
      "Order Point": 108.8,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 15.4412,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 68.0,
      "Order": 68.0,
      "L_Order": 68.0,
      "Store QOH": 2.0,
      "#/Box": 10.0,
      "# of Skus in Carton (PDM)": 10.0,
      "Avail Today": 49.0,
      "EOL AVAIL": 31.0,
      "Avail After Order": 109.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.04,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77312812",
      "Product ID (PDM)": 213834.0,
      "Alias": "HMRI 315",
      "FOB": "GUNTOWN",
      "Color": "PARCHMENT",
      "Factory Color": "PARCHMENT",
      "Theme": "LAKE BREEZE",
      "Description": "LAKE BREEZE CLUB/ARMLESS CUSH PARCHMENT",
      "Family": "1281",
      "Cube": 7.18,
      "Avg Daily Sales": 0.5333,
      "Weekly Sales": 3.7331,
      "Total Sales": 40.0,
      "QOH": 43.0,
      "Inbound": 30.0,
      "Available": 57.0,
      "Weeks of Stock": 15.2679,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 128.0,
      "Order Point": 128.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 11.5179,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 71.0,
      "Order": 71.0,
      "L_Order": 71.0,
      "Store QOH": 0.0,
      "#/Box": 2.0,
      "# of Skus in Carton (PDM)": 2.0,
      "Avail Today": 43.0,
      "EOL AVAIL": 71.0,
      "Avail After Order": 128.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.21,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "78811518",
      "Product ID (PDM)": 144641.0,
      "Alias": "HMRI MADURA NAVY",
      "FOB": "GUNTOWN",
      "Color": "NAVY",
      "Factory Color": "NAVY",
      "Theme": "MADURA NAVY",
      "Description": "P115-KP MADURA NAVY KID PILLOW",
      "Family": "1151",
      "Cube": 0.52,
      "Avg Daily Sales": 0.44,
      "Weekly Sales": 3.08,
      "Total Sales": 33.0,
      "QOH": 41.0,
      "Inbound": 0.0,
      "Available": 34.0,
      "Weeks of Stock": 11.039,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 105.6,
      "Order Point": 105.6,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 12.6623,
      "Qty To WHS": 0.0,
      "Qty From WHS": 1.0,
      "Calc. Order": 72.0,
      "Order": 72.0,
      "L_Order": 72.0,
      "Store QOH": 75.0,
      "#/Box": 16.0,
      "# of Skus in Carton (PDM)": 16.0,
      "Avail Today": 39.0,
      "EOL AVAIL": 27.0,
      "Avail After Order": 106.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.02,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77110648",
      "Product ID (PDM)": 22941.0,
      "Alias": "HMRI 304",
      "FOB": "GUNTOWN",
      "Color": "VAPOR",
      "Factory Color": "VAPOR",
      "Theme": "PLEASANT BAY",
      "Description": "PLEASANT BAY SOFA CUSHION SUNBRELLA VAPOR",
      "Family": "1064",
      "Cube": 22.96,
      "Avg Daily Sales": 0.4667,
      "Weekly Sales": 3.2669,
      "Total Sales": 35.0,
      "QOH": 24.0,
      "Inbound": 20.0,
      "Available": 35.0,
      "Weeks of Stock": 10.7143,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 112.0,
      "Order Point": 112.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 13.1633,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 77.0,
      "Order": 77.0,
      "L_Order": 77.0,
      "Store QOH": 5.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 43.0,
      "EOL AVAIL": 46.0,
      "Avail After Order": 112.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.85,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77300463",
      "Product ID (PDM)": 347607.0,
      "Alias": "HMRI P332",
      "FOB": "GUNTOWN",
      "Color": "MINERAL",
      "Factory Color": "MINERAL",
      "Theme": "LANAI",
      "Description": "LANAI CLUB CHAIR CUSHION LINDY MINERAL",
      "Family": "0046",
      "Cube": 12.64,
      "Avg Daily Sales": 1.0933,
      "Weekly Sales": 7.6531,
      "Total Sales": 82.0,
      "QOH": 102.0,
      "Inbound": 95.0,
      "Available": 183.0,
      "Weeks of Stock": 23.9111,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 262.4,
      "Order Point": 262.4,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 14.8955,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 79.0,
      "Order": 79.0,
      "L_Order": 79.0,
      "Store QOH": 65.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 114.0,
      "EOL AVAIL": 264.0,
      "Avail After Order": 262.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "18902141",
      "Product ID (PDM)": 337256.0,
      "Alias": "HMRI APOLLO INK",
      "FOB": "GUNTOWN",
      "Color": "INK",
      "Factory Color": "INK",
      "Theme": "GRACIE",
      "Description": "0200-PP-A-YM TP PILLOW PAIR",
      "Family": "0214",
      "Cube": 2.77,
      "Avg Daily Sales": 0.4533,
      "Weekly Sales": 3.1731,
      "Total Sales": 34.0,
      "QOH": 27.0,
      "Inbound": 6.0,
      "Available": 29.0,
      "Weeks of Stock": 9.1387,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 108.8,
      "Order Point": 108.8,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 8.1933,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 80.0,
      "Order": 80.0,
      "L_Order": 80.0,
      "Store QOH": 0.0,
      "#/Box": 6.0,
      "# of Skus in Carton (PDM)": 6.0,
      "Avail Today": 26.0,
      "EOL AVAIL": 31.0,
      "Avail After Order": 109.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.1,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "75512345",
      "Product ID (PDM)": 223924.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "SEAGULL",
      "Factory Color": "SEAGULL",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE SIDE CHR CUSH SEAGULL",
      "Family": "1234",
      "Cube": 1.1,
      "Avg Daily Sales": 0.56,
      "Weekly Sales": 3.92,
      "Total Sales": 42.0,
      "QOH": 60.0,
      "Inbound": 0.0,
      "Available": 52.0,
      "Weeks of Stock": 13.2653,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 134.4,
      "Order Point": 134.4,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 15.3061,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 82.0,
      "Order": 82.0,
      "L_Order": 82.0,
      "Store QOH": 58.0,
      "#/Box": 10.0,
      "# of Skus in Carton (PDM)": 10.0,
      "Avail Today": 60.0,
      "EOL AVAIL": 44.0,
      "Avail After Order": 134.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.04,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77412371",
      "Product ID (PDM)": 248282.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "CHARCOAL",
      "Factory Color": "CHARCOAL",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE OTTOMAN CUSH IO CHARCOAL",
      "Family": "1237",
      "Cube": 3.17,
      "Avg Daily Sales": 0.3867,
      "Weekly Sales": 2.7069,
      "Total Sales": 29.0,
      "QOH": 21.0,
      "Inbound": 0.0,
      "Available": 11.0,
      "Weeks of Stock": 4.064,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 92.8,
      "Order Point": 92.8,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 7.7586,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 82.0,
      "Order": 82.0,
      "L_Order": 82.0,
      "Store QOH": 25.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 21.0,
      "EOL AVAIL": 1.0,
      "Avail After Order": 93.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.09,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "78911318",
      "Product ID (PDM)": 177286.0,
      "Alias": "HMRI LAVISH PALM GREEN",
      "FOB": "GUNTOWN",
      "Color": "GREEN",
      "Factory Color": "GREEN",
      "Theme": "LAVISH PALM GREEN",
      "Description": "P113-TP LAV PALM GREEN PAIR OF PILLOWS",
      "Family": "1131",
      "Cube": 2.08,
      "Avg Daily Sales": 0.5067,
      "Weekly Sales": 3.5469,
      "Total Sales": 38.0,
      "QOH": 51.0,
      "Inbound": 0.0,
      "Available": 37.0,
      "Weeks of Stock": 10.4323,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 121.6,
      "Order Point": 121.6,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 14.0977,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 85.0,
      "Order": 85.0,
      "L_Order": 85.0,
      "Store QOH": 69.0,
      "#/Box": 8.0,
      "# of Skus in Carton (PDM)": 8.0,
      "Avail Today": 50.0,
      "EOL AVAIL": 23.0,
      "Avail After Order": 122.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.08,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77812343",
      "Product ID (PDM)": 223909.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "SEAGULL",
      "Factory Color": "SEAGULL",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE CLUB CHR CUSH SEAGULL",
      "Family": "1234",
      "Cube": 9.02,
      "Avg Daily Sales": 0.5733,
      "Weekly Sales": 4.0131,
      "Total Sales": 43.0,
      "QOH": 60.0,
      "Inbound": 0.0,
      "Available": 46.0,
      "Weeks of Stock": 11.4618,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 137.6,
      "Order Point": 137.6,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 14.9502,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 92.0,
      "Order": 92.0,
      "L_Order": 92.0,
      "Store QOH": 0.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 60.0,
      "EOL AVAIL": 32.0,
      "Avail After Order": 138.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.28,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "78911217",
      "Product ID (PDM)": 176234.0,
      "Alias": "HMRI LAVISH PALM MARINE",
      "FOB": "GUNTOWN",
      "Color": "MARINE",
      "Factory Color": "MARINE",
      "Theme": "LAVISH PALM MARINE",
      "Description": "P112-TP LAV PALM MAR PAIR OF PILLOWS",
      "Family": "1121",
      "Cube": 2.08,
      "Avg Daily Sales": 0.56,
      "Weekly Sales": 3.92,
      "Total Sales": 42.0,
      "QOH": 54.0,
      "Inbound": 0.0,
      "Available": 38.0,
      "Weeks of Stock": 9.6939,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 134.4,
      "Order Point": 134.4,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 13.5204,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 96.0,
      "Order": 96.0,
      "L_Order": 96.0,
      "Store QOH": 64.0,
      "#/Box": 8.0,
      "# of Skus in Carton (PDM)": 8.0,
      "Avail Today": 53.0,
      "EOL AVAIL": 22.0,
      "Avail After Order": 134.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.08,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "75607992",
      "Product ID (PDM)": 301515.0,
      "Alias": "HMRI 326",
      "FOB": "GUNTOWN",
      "Color": "WHITE",
      "Factory Color": "WHITE",
      "Theme": "RIVA",
      "Description": "RIVA DN ARM CHAIR CUSHION WHITE",
      "Family": "0799",
      "Cube": 1.07,
      "Avg Daily Sales": 0.6133,
      "Weekly Sales": 4.2931,
      "Total Sales": 46.0,
      "QOH": 43.0,
      "Inbound": 30.0,
      "Available": 47.0,
      "Weeks of Stock": 10.9472,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 147.2,
      "Order Point": 147.2,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 10.0155,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 100.0,
      "Order": 100.0,
      "L_Order": 100.0,
      "Store QOH": 0.0,
      "#/Box": 10.0,
      "# of Skus in Carton (PDM)": 10.0,
      "Avail Today": 43.0,
      "EOL AVAIL": 51.0,
      "Avail After Order": 147.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77112375",
      "Product ID (PDM)": 248261.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "CHARCOAL",
      "Factory Color": "CHARCOAL",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE SOFA CUSH IO CHARCOAL",
      "Family": "1237",
      "Cube": 22.97,
      "Avg Daily Sales": 0.5733,
      "Weekly Sales": 4.0131,
      "Total Sales": 43.0,
      "QOH": 46.0,
      "Inbound": 0.0,
      "Available": 32.0,
      "Weeks of Stock": 7.9734,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 137.6,
      "Order Point": 137.6,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 11.4618,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 106.0,
      "Order": 106.0,
      "L_Order": 106.0,
      "Store QOH": 25.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 46.0,
      "EOL AVAIL": 18.0,
      "Avail After Order": 138.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.85,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77512347",
      "Product ID (PDM)": 223922.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "SEAGULL",
      "Factory Color": "SEAGULL",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE CHAISE CUSH SEAGULL",
      "Family": "1234",
      "Cube": 9.19,
      "Avg Daily Sales": 0.5333,
      "Weekly Sales": 3.7331,
      "Total Sales": 40.0,
      "QOH": 34.0,
      "Inbound": 0.0,
      "Available": 20.0,
      "Weeks of Stock": 5.3571,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 128.0,
      "Order Point": 128.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 9.1071,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 108.0,
      "Order": 108.0,
      "L_Order": 108.0,
      "Store QOH": 0.0,
      "#/Box": 5.0,
      "# of Skus in Carton (PDM)": 5.0,
      "Avail Today": 34.0,
      "EOL AVAIL": 6.0,
      "Avail After Order": 128.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.34,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77112008",
      "Product ID (PDM)": 238790.0,
      "Alias": "HMRI 302",
      "FOB": "GUNTOWN",
      "Color": "STEEL",
      "Factory Color": "STEEL",
      "Theme": "PATMOS",
      "Description": "PATMOS SOFA CUSH STEEL",
      "Family": "1200",
      "Cube": 22.9,
      "Avg Daily Sales": 0.6267,
      "Weekly Sales": 4.3869,
      "Total Sales": 47.0,
      "QOH": 42.0,
      "Inbound": 12.0,
      "Available": 38.0,
      "Weeks of Stock": 8.6626,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 150.4,
      "Order Point": 150.4,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 8.8906,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 112.0,
      "Order": 112.0,
      "L_Order": 112.0,
      "Store QOH": 21.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 39.0,
      "EOL AVAIL": 35.0,
      "Avail After Order": 150.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.85,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "93302102",
      "Product ID (PDM)": 324247.0,
      "Alias": "HMRI RUST POUF",
      "FOB": "GUNTOWN",
      "Color": "RUST",
      "Factory Color": "RUST",
      "Theme": "PALL",
      "Description": "P210-AO ENDURANCE RUST POUF",
      "Family": "0210",
      "Cube": 4.85,
      "Avg Daily Sales": 0.68,
      "Weekly Sales": 4.76,
      "Total Sales": 51.0,
      "QOH": 50.0,
      "Inbound": 6.0,
      "Available": 46.0,
      "Weeks of Stock": 9.6639,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 163.2,
      "Order Point": 163.2,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 10.5042,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 117.0,
      "Order": 117.0,
      "L_Order": 117.0,
      "Store QOH": 53.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 50.0,
      "EOL AVAIL": 42.0,
      "Avail After Order": 163.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77310440",
      "Product ID (PDM)": 84239.0,
      "Alias": "HMRI 304",
      "FOB": "GUNTOWN",
      "Color": "INDIGO",
      "Factory Color": "INDIGO",
      "Theme": "PLEASANT BAY",
      "Description": "PLEASANT BAY CLUB CHAIR CUSHION SUNBRELLA INDIGO",
      "Family": "1044",
      "Cube": 8.71,
      "Avg Daily Sales": 0.8267,
      "Weekly Sales": 5.7869,
      "Total Sales": 62.0,
      "QOH": 43.0,
      "Inbound": 40.0,
      "Available": 74.0,
      "Weeks of Stock": 12.788,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 198.4,
      "Order Point": 198.4,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 14.3433,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 124.0,
      "Order": 124.0,
      "L_Order": 124.0,
      "Store QOH": 2.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 83.0,
      "EOL AVAIL": 105.0,
      "Avail After Order": 198.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.28,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "75512004",
      "Product ID (PDM)": 238786.0,
      "Alias": "HMRI 302",
      "FOB": "GUNTOWN",
      "Color": "STEEL",
      "Factory Color": "STEEL",
      "Theme": "PATMOS",
      "Description": "PATMOS DN S/C CUSH STEEL",
      "Family": "1200",
      "Cube": 1.0,
      "Avg Daily Sales": 0.9333,
      "Weekly Sales": 6.5331,
      "Total Sales": 70.0,
      "QOH": 92.0,
      "Inbound": 30.0,
      "Available": 96.0,
      "Weeks of Stock": 14.6939,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 224.0,
      "Order Point": 224.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 13.4694,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 128.0,
      "Order": 128.0,
      "L_Order": 128.0,
      "Store QOH": 2.0,
      "#/Box": 10.0,
      "# of Skus in Carton (PDM)": 10.0,
      "Avail Today": 88.0,
      "EOL AVAIL": 100.0,
      "Avail After Order": 224.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.04,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77510444",
      "Product ID (PDM)": 146999.0,
      "Alias": "HMRI 304",
      "FOB": "GUNTOWN",
      "Color": "INDIGO",
      "Factory Color": "INDIGO",
      "Theme": "PLEASANT BAY",
      "Description": "PLEASANT BAY CHAISE CUSHION SUNBRELLA INDIGO",
      "Family": "1044",
      "Cube": 6.3,
      "Avg Daily Sales": 0.64,
      "Weekly Sales": 4.48,
      "Total Sales": 48.0,
      "QOH": 19.0,
      "Inbound": 12.0,
      "Available": 23.0,
      "Weeks of Stock": 5.1339,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 153.6,
      "Order Point": 153.6,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 6.9196,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 131.0,
      "Order": 131.0,
      "L_Order": 131.0,
      "Store QOH": 0.0,
      "#/Box": 6.0,
      "# of Skus in Carton (PDM)": 6.0,
      "Avail Today": 31.0,
      "EOL AVAIL": 27.0,
      "Avail After Order": 154.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.25,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "78911510",
      "Product ID (PDM)": 170261.0,
      "Alias": "HMRI MADURA NAVY",
      "FOB": "GUNTOWN",
      "Color": "NAVY",
      "Factory Color": "NAVY",
      "Theme": "MADURA NAVY",
      "Description": "P115-TP MADURA NAVY PAIR OF PILLOWS",
      "Family": "1151",
      "Cube": 2.08,
      "Avg Daily Sales": 0.84,
      "Weekly Sales": 5.88,
      "Total Sales": 63.0,
      "QOH": 93.0,
      "Inbound": 0.0,
      "Available": 70.0,
      "Weeks of Stock": 11.9048,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 201.6,
      "Order Point": 201.6,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 15.1361,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 132.0,
      "Order": 132.0,
      "L_Order": 132.0,
      "Store QOH": 69.0,
      "#/Box": 8.0,
      "# of Skus in Carton (PDM)": 8.0,
      "Avail Today": 89.0,
      "EOL AVAIL": 47.0,
      "Avail After Order": 202.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.08,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77307998",
      "Product ID (PDM)": 301521.0,
      "Alias": "HMRI 326",
      "FOB": "GUNTOWN",
      "Color": "WHITE",
      "Factory Color": "WHITE",
      "Theme": "RIVA",
      "Description": "RIVA CLUB CHAIR CUSHION WHITE",
      "Family": "0799",
      "Cube": 8.71,
      "Avg Daily Sales": 0.76,
      "Weekly Sales": 5.32,
      "Total Sales": 57.0,
      "QOH": 48.0,
      "Inbound": 0.0,
      "Available": 42.0,
      "Weeks of Stock": 7.8947,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 182.4,
      "Order Point": 182.4,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 9.0226,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 140.0,
      "Order": 140.0,
      "L_Order": 140.0,
      "Store QOH": 10.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 48.0,
      "EOL AVAIL": 36.0,
      "Avail After Order": 182.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "75612816",
      "Product ID (PDM)": 204965.0,
      "Alias": "HMRI 315",
      "FOB": "GUNTOWN",
      "Color": "PARCHMENT",
      "Factory Color": "PARCHMENT",
      "Theme": "LAKE BREEZE",
      "Description": "LAKE BREEZE DN/SWL CUSH PARCHMENT",
      "Family": "1281",
      "Cube": 3.58,
      "Avg Daily Sales": 0.8,
      "Weekly Sales": 5.6,
      "Total Sales": 60.0,
      "QOH": 75.0,
      "Inbound": 0.0,
      "Available": 47.0,
      "Weeks of Stock": 8.3929,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 192.0,
      "Order Point": 192.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 13.3929,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 145.0,
      "Order": 145.0,
      "L_Order": 145.0,
      "Store QOH": 14.0,
      "#/Box": 3.0,
      "# of Skus in Carton (PDM)": 3.0,
      "Avail Today": 75.0,
      "EOL AVAIL": 19.0,
      "Avail After Order": 192.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.13,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77307695",
      "Product ID (PDM)": 268001.0,
      "Alias": "HMRI 326",
      "FOB": "GUNTOWN",
      "Color": "DOVE",
      "Factory Color": "DOVE",
      "Theme": "RIVA",
      "Description": "RIVA CLUB CHAIR CUSHION DOVE",
      "Family": "0769",
      "Cube": 8.71,
      "Avg Daily Sales": 0.7867,
      "Weekly Sales": 5.5069,
      "Total Sales": 59.0,
      "QOH": 33.0,
      "Inbound": 10.0,
      "Available": 35.0,
      "Weeks of Stock": 6.3559,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 188.8,
      "Order Point": 188.8,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 5.9927,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 154.0,
      "Order": 154.0,
      "L_Order": 154.0,
      "Store QOH": 4.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 33.0,
      "EOL AVAIL": 37.0,
      "Avail After Order": 189.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "12612241",
      "Product ID (PDM)": 237629.0,
      "Alias": "HMRI 9552",
      "FOB": "GUNTOWN",
      "Color": "MARINE",
      "Factory Color": "MARINE",
      "Theme": "BEDFORD PARK",
      "Description": "1224-56 COCKTAIL OTTOMAN",
      "Family": "1224",
      "Cube": 15.73,
      "Avg Daily Sales": 0.9067,
      "Weekly Sales": 6.3469,
      "Total Sales": 68.0,
      "QOH": 44.0,
      "Inbound": 30.0,
      "Available": 64.0,
      "Weeks of Stock": 10.084,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 217.6,
      "Order Point": 217.6,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 6.6176,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 154.0,
      "Order": 154.0,
      "L_Order": 154.0,
      "Store QOH": 30.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 42.0,
      "EOL AVAIL": 84.0,
      "Avail After Order": 218.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.54,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77310642",
      "Product ID (PDM)": 86948.0,
      "Alias": "HMRI 304",
      "FOB": "GUNTOWN",
      "Color": "VAPOR",
      "Factory Color": "VAPOR",
      "Theme": "PLEASANT BAY",
      "Description": "PLEASANT BAY CLUB CHAIR CUSHION SUNBRELLA VAPOR",
      "Family": "1064",
      "Cube": 8.71,
      "Avg Daily Sales": 1.0533,
      "Weekly Sales": 7.3731,
      "Total Sales": 79.0,
      "QOH": 63.0,
      "Inbound": 30.0,
      "Available": 76.0,
      "Weeks of Stock": 10.3074,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 252.8,
      "Order Point": 252.8,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 12.3418,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 177.0,
      "Order": 177.0,
      "L_Order": 177.0,
      "Store QOH": 9.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 91.0,
      "EOL AVAIL": 89.0,
      "Avail After Order": 253.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.28,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77312379",
      "Product ID (PDM)": 248275.0,
      "Alias": "HMRI 316",
      "FOB": "GUNTOWN",
      "Color": "CHARCOAL",
      "Factory Color": "CHARCOAL",
      "Theme": "LAKE TAHOE",
      "Description": "LAKE TAHOE CLUB CHAIR CUSH IO CHARCOAL",
      "Family": "1237",
      "Cube": 9.02,
      "Avg Daily Sales": 1.12,
      "Weekly Sales": 7.84,
      "Total Sales": 84.0,
      "QOH": 94.0,
      "Inbound": 0.0,
      "Available": 74.0,
      "Weeks of Stock": 9.4388,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 268.8,
      "Order Point": 268.8,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 11.9898,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 195.0,
      "Order": 195.0,
      "L_Order": 195.0,
      "Store QOH": 49.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 94.0,
      "EOL AVAIL": 54.0,
      "Avail After Order": 269.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.28,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "77312002",
      "Product ID (PDM)": 238794.0,
      "Alias": "HMRI 302",
      "FOB": "GUNTOWN",
      "Color": "STEEL",
      "Factory Color": "STEEL",
      "Theme": "PATMOS",
      "Description": "PATMOS CLUB/SWVL CUSH STEEL",
      "Family": "1200",
      "Cube": 9.0,
      "Avg Daily Sales": 1.8267,
      "Weekly Sales": 12.7869,
      "Total Sales": 137.0,
      "QOH": 94.0,
      "Inbound": 80.0,
      "Available": 118.0,
      "Weeks of Stock": 9.2284,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 438.4,
      "Order Point": 438.4,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 6.6475,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 320.0,
      "Order": 320.0,
      "L_Order": 320.0,
      "Store QOH": 42.0,
      "#/Box": 1.0,
      "# of Skus in Carton (PDM)": 1.0,
      "Avail Today": 85.0,
      "EOL AVAIL": 142.0,
      "Avail After Order": 438.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.28,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "75610444",
      "Product ID (PDM)": 188350.0,
      "Alias": "HMRI 304",
      "FOB": "GUNTOWN",
      "Color": "INDIGO",
      "Factory Color": "INDIGO",
      "Theme": "PLEASANT BAY",
      "Description": "PLEASANT BAY DINING CHAIR CUSHION INDIGO",
      "Family": "1044",
      "Cube": 1.07,
      "Avg Daily Sales": 1.9333,
      "Weekly Sales": 13.5331,
      "Total Sales": 145.0,
      "QOH": 178.0,
      "Inbound": 0.0,
      "Available": 138.0,
      "Weeks of Stock": 10.197,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 464.0,
      "Order Point": 464.0,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 12.4138,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 326.0,
      "Order": 326.0,
      "L_Order": 326.0,
      "Store QOH": 51.0,
      "#/Box": 10.0,
      "# of Skus in Carton (PDM)": 10.0,
      "Avail Today": 168.0,
      "EOL AVAIL": 98.0,
      "Avail After Order": 464.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.04,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    },
    {
      "SKU": "75607699",
      "Product ID (PDM)": 267995.0,
      "Alias": "HMRI 326",
      "FOB": "GUNTOWN",
      "Color": "DOVE",
      "Factory Color": "DOVE",
      "Theme": "RIVA",
      "Description": "RIVA DN ARM CHAIR CUSHION DOVE",
      "Family": "0769",
      "Cube": 1.07,
      "Avg Daily Sales": 2.7467,
      "Weekly Sales": 19.2269,
      "Total Sales": 206.0,
      "QOH": 158.0,
      "Inbound": 0.0,
      "Available": 128.0,
      "Weeks of Stock": 6.6574,
      "Daily STDEV": 0.0,
      "Safe Stock": 0.0,
      "Replenishment Stock": 659.2,
      "Order Point": 659.2,
      "ADTS": 0.0,
      "Days To Next Order": 0.0,
      "WOSOH": 8.2178,
      "Qty To WHS": 0.0,
      "Qty From WHS": 0.0,
      "Calc. Order": 531.0,
      "Order": 531.0,
      "L_Order": 531.0,
      "Store QOH": 30.0,
      "#/Box": 10.0,
      "# of Skus in Carton (PDM)": 10.0,
      "Avail Today": 158.0,
      "EOL AVAIL": 98.0,
      "Avail After Order": 659.0,
      "Order Ratio": 0.0,
      "Production Time": 120.0,
      "Transit Time": 120.0,
      "Intradivisional": 0.0,
      "Load Factor": 0.0,
      "SKU Group": "",
      "Discontinued": false,
      "Inactive": false,
      "To Be Dropped": false
    }
  ]
}
